/*
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, Suspense, useRef } from 'react';
import TextField from '@material-ui/core/TextField';
import { Dropdown, Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import Box from '@material-ui/core/Box';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
// IMPORT CUSTOM COMPONENT
import moment from 'moment';

import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DiscrepancyWarningMsg from './gridComponents/DiscrepancyWarningMsg';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import AllocatePaymentTab from './AllocatePaymentTab';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';
// import custom function
import {
  closeTab,
  decrementIncrementQtr,
  getCommonDropdownList,
  handleQuarterFormate,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchAllocatePaymentHederData,
  getPartiallyPaidDrugs,
  handleErrorMessageForAllocatePayment,
  getDeclareCheckAllocation,
  clearReduxAllocatePaymentThirdScreen,
  getDiscrepanciesList,
  getUnallocatedBalanceAmt,
  getRosiAllocatePaymentDetail,
  addReduxDataUpdateAllocatePaymentDetailTab,
  setUpdateDetails,
  dispatchROSIGridList,
  deallocateNDCStore,
  dispatchCommonDropdown,
  setDisabledValIntPaid,
  dispatchIsIDBLMfgUB,
  setActiveDetailScreenTabs,
  setPopupCancelFlag,
  dispatchDiscrepancyNDCs,
  resetPopupAcknowledged,
  isHandleOkPayRem,
} from '../store/Actions';
import {
  ALLOCATE_PAYMENT_DETAIL_SCREEN_URL,
  ROSI_PQAS_ALERT_TITLE,
  SAVE_AGAIN_ALERT_MESSAGE,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { getInvoiceDetailsByInvoiceNum } from '../../../Display/invoice/store/actions';
import {
  getSearchCheckResults,
  maintainCheckErrorMessageAction,
  maintainCheckFormErrorAction,
  maintainCheckReqAction,
} from '../../../Maintain/Check/store/actions';
import {
  dispatchPQASGridLevelActions,
  noPaySuspended,
  dispatchGetInvoiceHeader,
  saveAllocatePaymentDetails,
  dispatchSaveDetailsResponse,
  deallocateNdcPqasStore,
  dispatchGetDeletedRow,
  getPQASTabDiscrepanciesList,
  setDisabledValIntPaidPQAS,
  setOnLoadPQASGridError,
  updateIdsDealloc,
  addOrDuplicateNDCPQASObjData,
  dispatchIsColumnDone,
  clearSuspend,
  setIsCanceling,
  dispatchColIdForPqas,
} from '../PQASTab/store/Actions';

import {
  onLoadPqasGrid,
  pqasPageChanges,
  roundOffAmt,
} from '../PQASTab/components/gridComponents/pqasUtils';
import {
  calculateTotalSum,
  roundOffInvoiceCorrectionAmt,
  roundOffPaidAmount,
  roundOffWithheldInvcAmount,
  setErrorMessageForDiscrepancy,
} from './gridComponents/tableHead';
import {
  getAllocatePaymentScreenData,
  removeWhiteSpaceForNDC,
  replaceCommaIntoWhiteSpace,
  replaceHyphenWithZero,
} from './gridComponents/ROSIUtils';
import {
  roundOffPaidThisTransactionAmtAmount,
  roundOffRevisedInoiveAmount,
  roundOffPriorPaidAmtAmount,
  setErrorMessageForPQASDiscrepancy,
  roundOffCurrMatPaidAmount,
  roundOffCurrURA,
  roundOffTotReimbursedAmt,
  roundOffXorigAmtPttAmount,
} from '../PQASTab/components/gridComponents/tableHead';

const AllocatePaymentROSIGridComponent = React.lazy(() =>
  import('./AllocatePaymentROSIGridComponent')
);
const AllocatePaymentPQASGridComponent = React.lazy(() =>
  import('../PQASTab/components/AllocatePaymentPQASGridComponent')
);

const DetailScreenAllocatePaymentComponent = React.memo(() => {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function
  const activeInvNum = window.location.pathname
    ?.split(ALLOCATE_PAYMENT_DETAIL_SCREEN_URL)[1]
    ?.split('-')[1];
  const activeCheckLogNum = window.location.pathname
    ?.split(ALLOCATE_PAYMENT_DETAIL_SCREEN_URL)[1]
    ?.split('-')[0];
  const updateDetailsAllData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.updateDetails
  );
  const AllocatePaymentReducer = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer
  );
  const searchPickInvAssociateScreenObj = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.searchPickInvAssociateScreenObj
  );
  const pervSearchPickInvScreenData = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.pervSearchPickInvScreenData
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.AllocatePaymentReducer?.errorMessagesInRedux
  );
  const headerAllocatePaymentData = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.headerAllocatePaymentData
  );
  const headerAllocatePaymentAmount = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.headerAllocatePaymentAmtNotify
  );
  const allocatePaymentHeaderDetail = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.headerAllocatePaymentData[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const activeScreenDetails = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer.activeDetailScreenTabs
  );
  const rsAddValuesRowData = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.rsAddValueList[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const deallocateNdcPqas = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer2?.deallocateNdcPqas[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );

  const deallocateNdcRosi = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.deallocateNdcRosi[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );

  const addOrDuplicateNDCAll = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer2?.addOrDuplicateNDCPQASObj
  );
  const addOrDuplicateNDCSingle = useSelector((state) => {
    return state.sharedState.AllocatePaymentReducer2
      ?.addOrDuplicateNDCPQASObj?.[`${activeInvNum}-${activeCheckLogNum}`];
  });

  const DuplicateROSIGridData = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.duplicateROSIGridList[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const duplicatePQASGridData = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer2?.duplicatePQASGrid[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const fetchSearchScreenData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.pervSearchScreenData
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.CommentListData;
  });
  const activeInvoiceNumArray = useSelector(
    (state) => state?.sharedState?.AllocatePaymentReducer?.activeInvoiceNum
  );

  const ROSIGirdAllRowData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.ROSIGridList
  );
  const ROSIGridRowData = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.ROSIGridList[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const pqasGridLevelAllActions = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer2?.pqasGridLevelActions
  );
  const pqasGridLevelActions = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer2?.pqasGridLevelActions[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const disabledIntPaidAllPQAS = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer2?.disabledIntPaidColObj
  );
  const singleDisabledIntPaidColObjPqas = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer2?.disabledIntPaidColObj[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const loadPQASGridErrorAlert = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer2?.loadPQASGridErrorObj
  );
  const disabledIntPaidAllROSI = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.disabledIntPaidColObjROSI
  );
  const singleDisabledIntPaidColObjRosi = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.disabledIntPaidColObjROSI[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const getInvoiceHeader = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer2?.getInvoiceHeader
  );
  // saving response from SAVE API
  const saveDetailApiResponse = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer2?.saveDetailResponse
  );

  const pqasGridData = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer2?.pqasgridData[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const getPreInitData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer2?.preInitializeResponse
  );

  // NO pay Suspended selector func
  const npSuspended = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer2?.npSuspended
  );
  const summaryGridReduxData = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.summaryGridList[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const pqasSummaryGridList = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer2?.pqasSummaryGridList[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const addEditAllocatePaymentDetailAllScreenObj = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.addEditAllocatePaymentDetailObj
  );

  const addEditAllocatePaymentDetailObj = useSelector(
    (state) =>
      state.sharedState.AllocatePaymentReducer?.addEditAllocatePaymentDetailObj[
        `${activeInvNum}-${activeCheckLogNum}`
      ]
  );
  const isIDBLMfgUB = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.isIDBLMfgUB
  );
  const logInUserID = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const isColumnDone = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer2?.isColumnDone
  );
  const isPopupCancelled = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.isPopupCancelled
  );
  const discrepancyNDCsData = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.discNDCList
  );
  const hasAcknowledged = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.hasAcknowledged
  );
  const getIsHandleOkPayRem = useSelector(
    (state) => state.sharedState.AllocatePaymentReducer?.isHandleOkPayRem
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  // variable declaration
  const [flag, setFlag] = useState(false);
  const [flag1, setFlag1] = useState(false);
  const [flag2, setFlag2] = useState(false);
  const [allocateFlag, setAllocateFlag] = useState(false);
  const tabKey = `${activeInvNum}-${activeCheckLogNum}`;
  const [handleTabValue, setHandleTabValue] = useState(false);
  const [saveApiRespnse, setSaveApirespnse] = useState('');
  const [fullScreenViewForFirstGrid, setFullScreenViewForFirstGrid] = useState(
    addEditAllocatePaymentDetailObj?.fullScreenViewForFirstGrid
  );
  const [fullScreenViewForSecondGrid, setFullScreenViewForSecondGrid] =
    useState(addEditAllocatePaymentDetailObj?.fullScreenViewForSecondGrid);
  const [open, setOpen] = useState(false);
  const [openTabClose, setOpenTabClose] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [saveView, setSaveView] = useState(false);
  const [saveDeallocateMsg, setSaveDeallocateMsg] = useState(false);
  const [stringDeallocateRowNums, setStringDeallocateRowNums] = useState('');
  const [checkAllocatedView, setCheckAllocatedView] = useState(false);
  const [checkAllocated, setCheckAllocated] = useState(false);
  const [interestPaymentExistsView, setInterestPaymentExistsView] =
    useState(false);
  const [commonDropdownList, setCommonDropdownList] = useState([]);
  const [disabledSaveCancelBtn, setDisabledSaveCancelBtn] = useState(true);

  const [showComments, setShowComments] = useState(false);
  const [tabValue, setTabValue] = useState(
    addEditAllocatePaymentDetailObj?.tabValue || 'one'
  );
  const [warningAlert, setWarningAlert] = useState(false);
  const [unallocatedBalanceAlert, setUnallocatedBalanceAlert] = useState(false);
  const [unallocatedBalErrorMsg, setUnallocatedBalErrorMsg] = useState(false);
  const [discrepancyAlert, setDiscrepancyAlert] = useState(false);
  const [discrepancyMsg, setDiscrepancyMsg] = useState([]);
  const [sameAmountForCheck, setSameAmountForCheck] = useState(false);
  const [reOpenNewTab, setReOpenNewTab] = useState(false);
  const [declareCheckUnallocatedMsg, setDeclareCheckUnallocatedMsg] =
    useState('');
  const [checkNotAssociatedWithInvoice, setCheckNotAssociatedWithInvoice] =
    useState(false);
  const [warningMessage, setWaringMessage] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [preValues, setPreValues] = useState({
    ib_retrieved: false,
    ib_opening: false,
    idec_invoiceNum: '',
    il_checkNum: '',
    idbl_ub: '',
    currentQtr: handleQuarterFormate(allocatePaymentHeaderDetail?.qtr),
    prevQtr: decrementIncrementQtr(
      handleQuarterFormate(allocatePaymentHeaderDetail?.qtr),
      0
    ),
  });
  const [onCancelSave, setOnCancelSave] = React.useState(false);
  const [allocateDetailObj, setAllocateDetailObj] = useState({});
  const [saveAgainAlert, setSaveAgainAlert] = useState(false);
  const [fieldsValidity, setFieldsValidity] = useState({});
  const [summaryGridPopup, setSummaryGridPopup] = React.useState(false);
  const [summaryGridMsg, setSummaryGridMsg] = React.useState(false);
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  React.useEffect(() => {
    setIsEnablebyRole(
      !checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
    );
  }, []);
  React.useEffect(() => {
    const isValid = Object.values(fieldsValidity).every(
      (isValid) => isValid === true
    );
    setDisabledSaveCancelBtn(!isValid);
  }, [fieldsValidity]);

  // Handle the field errors and set validity
  const handleFieldError = (fieldId, isValid) => {
    setFieldsValidity((prevState) => ({
      ...prevState,
      [fieldId]: isValid,
    }));
  };

  const hasInvalidValueError = (errorMessagesFromRedux) => {
    return Object.values(errorMessagesFromRedux?.detailScreenErrors || {}).some(
      (errorArray) =>
        Array.isArray(errorArray) &&
        errorArray.some((item) =>
          item.message.includes(constantMessageData.DASH_ONLY_MSG)
        )
    );
  };

  // handling clear redux store after close tab
  const handleClearReduxData = (invNum, checkLogNum, params) => {
    dispatch(
      clearReduxAllocatePaymentThirdScreen(invNum, checkLogNum, history, params)
    );
    dispatch(dispatchColIdForPqas(''));
  };
  const currentTabObj = addEditAllocatePaymentDetailAllScreenObj?.[tabKey];
  const closedRef = useRef(null);
  // // handling allocated amount header
  // React.useEffect(() => {
  //   if (
  //     headerAllocatePaymentAmount &&
  //     headerAllocatePaymentAmount.isPQASScreen
  //   ) {
  //     setAllocateDetailObj({
  //       ...allocatePaymentHeaderDetail,
  //       totAllocatedAmt: allocatePaymentHeaderDetail?.totAllocatedAmt || 0,
  //     });
  //   }
  // }, [headerAllocatePaymentAmount]);
  // handling enable save
  React.useEffect(() => {
    setTabValue(currentTabObj?.tabValue || 'one');
  }, [tabKey, currentTabObj?.tabValue]);
  React.useEffect(() => {
    //let timeId = null;
    //timeId = setTimeout(() => {
    setAllocateDetailObj({
      ...allocatePaymentHeaderDetail,
      checkAmt: allocatePaymentHeaderDetail?.checkAmt || 0,
      isROSIScreen: false,
      isPQASScreen: false,
      totAllocatedAmt: allocatePaymentHeaderDetail?.totAllocatedAmt || 0,
      ccCommentsExist: allocatePaymentHeaderDetail?.ccCommentsExist || 0,
    });
    if (
      updateDetailsAllData[`${activeInvNum}-${activeCheckLogNum}`] &&
      Object.keys(updateDetailsAllData[`${activeInvNum}-${activeCheckLogNum}`])
        .length > 0
    ) {
      setDisabledSaveCancelBtn(
        updateDetailsAllData[`${activeInvNum}-${activeCheckLogNum}`]?.flag
      );
    } else {
      setDisabledSaveCancelBtn(true);
    }
    if (
      !(
        disabledIntPaidAllPQAS &&
        Object.keys(disabledIntPaidAllPQAS)?.filter(
          (x) =>
            x?.toString() === `${activeInvNum}-${activeCheckLogNum}`?.toString()
        )?.length > 0
      )
    ) {
      const newObjPQAS = disabledIntPaidAllPQAS;
      newObjPQAS[`${activeInvNum}-${activeCheckLogNum}`] = {
        pqasGridIntPaidColumnDisabled: false,
        summaryGirdIntPaidColumnDisabled: false,
        isSave: false,
      };
      dispatch(setDisabledValIntPaidPQAS(newObjPQAS));
    }
    //}, 100);
    // return () => clearTimeout(timeId);
  }, [activeInvNum]);
  React.useEffect(() => {
    if (
      updateDetailsAllData[`${activeInvNum}-${activeCheckLogNum}`] &&
      Object.keys(updateDetailsAllData[`${activeInvNum}-${activeCheckLogNum}`])
        .length > 0
    ) {
      setDisabledSaveCancelBtn(
        updateDetailsAllData[`${activeInvNum}-${activeCheckLogNum}`]?.flag
      );
    } else {
      setDisabledSaveCancelBtn(true);
    }
  }, [updateDetailsAllData]);
  //tracking ROSI/PQAS screen data for validation
  React.useEffect(() => {
    if (activeCheckLogNum && activeInvNum) {
      const tabInfo = {
        checkNumber: activeCheckLogNum,
        invoiceNumber: activeInvNum,
        tabId: `${activeCheckLogNum}${activeInvNum}`,
      };
      const tabInfoDispatch = [...activeScreenDetails, tabInfo];
      dispatch(setActiveDetailScreenTabs(tabInfoDispatch));
    }
  }, [activeCheckLogNum, activeInvNum]);
  // handling onPage load call service
  React.useEffect(() => {
    getCommonDropdownList({
      codeDomainList: ['ADJUSTMENT_DISPUTE_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
      dispatch(dispatchCommonDropdown(res));
    });
    const invoiceNumArrList = activeInvoiceNumArray;
    if (
      invoiceNumArrList &&
      invoiceNumArrList?.filter((x) => x.active)?.length > 5
    ) {
      const tempObj =
        headerAllocatePaymentData[
          `${invoiceNumArrList[0].invoiceNum}-${invoiceNumArrList[0].checkLogNum}`
        ];
      handleClearReduxData(tempObj?.invoiceNum, tempObj?.checkLogNum);
    }

    dispatch(
      getPartiallyPaidDrugs({
        invoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
      })
    );
    // if (parseFloat(allocatePaymentHeaderDetail?.idblmfgUB) > 0) {
    //   setUnallocatedBalanceAlert(true);
    //   setModalTitle(ROSI_PQAS_ALERT_TITLE);
    //   setUnallocatedBalErrorMsg(
    //     `Manufacturer ${
    //       allocatePaymentHeaderDetail?.mfgId
    //     } has an unallocated balance of $ ${parseFloat(
    //       allocatePaymentHeaderDetail?.idblmfgUB
    //     )} ${constantMessageData.UNALLOCATED_BALANCE_ERROR_MSG}`
    //   );
    // }
    if (
      allocatePaymentHeaderDetail?.checkNotAssociatedWithInvoice &&
      fetchSearchScreenData.state?.allocateFrom === 'Credit'
    ) {
      setCheckNotAssociatedWithInvoice(true);
      setModalTitle(ROSI_PQAS_ALERT_TITLE);
      setWarningAlert(true);
      setWaringMessage(
        allocatePaymentHeaderDetail?.checkNotAssociatedWithInvoice
      );
    }
    if (
      parseFloat(allocatePaymentHeaderDetail?.totAllocatedAmt) ===
        parseFloat(allocatePaymentHeaderDetail?.checkAmt) &&
      allocatePaymentHeaderDetail?.allocationCompleteInd != 1 &&
      !isPopupCancelled
    ) {
      setSameAmountForCheck(true);
      setModalTitle(ROSI_PQAS_ALERT_TITLE);
      setWaringMessage(constantMessageData.ALLOCATE_AMT_CHECK_AMT_SAME_ERROR);
    }
    // onLoadPqasGrid(preValues);
    preInitialization();
    handleScrollToEvent();
    return () => {
      dispatch(dispatchSaveDetailsResponse({}));
    };
  }, []);
  React.useEffect(() => {
    if (activeInvNum) {
      setDiscrepancyMsg([]);
      dispatch(dispatchSaveDetailsResponse({}));
    }
  }, [activeInvNum]);
  React.useEffect(() => {
    if (parseFloat(allocatePaymentHeaderDetail?.idblmfgUB) > 0 && isIDBLMfgUB) {
      setUnallocatedBalanceAlert(true);
      setModalTitle(ROSI_PQAS_ALERT_TITLE);
      setUnallocatedBalErrorMsg(
        `Manufacturer ${
          allocatePaymentHeaderDetail?.mfgId
        } has an unallocated balance of $ ${parseFloat(
          allocatePaymentHeaderDetail?.idblmfgUB
        )} ${constantMessageData.UNALLOCATED_BALANCE_ERROR_MSG}`
      );
    }
  }, [isIDBLMfgUB]);
  const deAllocateNdcRosi = React.useMemo(() => {
    let arr = [];
    if (deallocateNdcRosi && deallocateNdcRosi.length > 0) {
      arr = deallocateNdcRosi;
    }
    return arr;
  }, [deallocateNdcRosi]);
  const deAllocateNdcPqas = React.useMemo(() => {
    let arr = [];
    if (deallocateNdcPqas && deallocateNdcPqas.length > 0) {
      arr = deallocateNdcPqas.map((item) => {
        return {
          ...item,
          prevQtr: pqasGridLevelActions?.pgQtrVal,
          idecPrevInvoiceNum:
            getInvoiceHeader?.postInitByInvoiceHeaderResp?.[0]
              ?.idecPrevInvoiceNum,
        };
      });
    }
    return arr;
  }, [deallocateNdcPqas]);

  // no pay suspended(Allocate part3)

  React.useEffect(() => {
    if (
      npSuspended &&
      npSuspended.message === 'SUCESS' &&
      npSuspended?.data?.paymentAssociatedNumber > 0
    ) {
      const updateTabs = JSON.parse(
        localStorage.getItem('tabItemsData') || '[]'
      );
      updateTabs.forEach(() => {
        setModalTitle('ROSI/PQAS');
      });
      setWarningAlert(true);
      setWaringMessage(constantMessageData.ALREADY_EXIST_PAYMENT_FOR_CHECK);
    } else if (
      npSuspended &&
      npSuspended.message === 'SUCESS' &&
      npSuspended?.data?.paymentAssociatedNumber === 0 &&
      npSuspended?.data?.messageVO === 'Leave now and suspend check'
    ) {
      const updateTabs = JSON.parse(
        localStorage.getItem('tabItemsData') || '[]'
      );
      updateTabs.forEach((item) => {
        setModalTitle(item.value);
      });
      setSaveView(true);
      dispatch(clearSuspend());
    }
  }, [npSuspended]);

  // No apy suspended(Allocate Payment part3)
  React.useEffect(() => {
    if (
      npSuspended &&
      npSuspended.message === 'SUCESS' &&
      npSuspended?.data?.paymentAssociatedNumber === 0 &&
      npSuspended?.data?.messageVO === null
    ) {
      handleDisabledIntPaidStoreVal();
      const tempObj = headerAllocatePaymentData;
      tempObj[`${activeInvNum}-${activeCheckLogNum}`].allocationCompleteInd = 1;
      setAllocateDetailObj({
        ...allocateDetailObj,
        allocationCompleteInd: 1,
      });
      dispatch(
        dispatchAllocatePaymentHederData(
          tempObj,
          activeInvNum,
          activeCheckLogNum
        )
      );
      let localErr =
        errorMessagesFromRedux?.detailScreenErrors?.[
          `${activeInvNum}-${activeCheckLogNum}`
        ] || [];
      localErr = localErr?.filter((item) => item.errorType !== 'errorMessage');
      localErr.push({
        field: 'SucessMessage',
        errorType: 'SucessMessage',
        message: constantMessageData.SUCCESSMESSAGE_GENERIC,
      });

      // let activeInvNum
      const obj = { ...errorMessagesFromRedux?.detailScreenErrors };
      obj[`${activeInvNum}-${activeCheckLogNum}`] = localErr;
      handleScrollToEvent();
      dispatch(
        handleErrorMessageForAllocatePayment({
          detailScreenErrors: obj,
          searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
            ? errorMessagesFromRedux?.searchScreenErrors
            : [],
        })
      );
    }
  }, [npSuspended]);

  React.useEffect(() => {
    if (
      saveDetailApiResponse?.data?.apiResponse === 'Save Bypass Update' ||
      saveDetailApiResponse?.data?.apiResponse === 'Successfully Saved'
    ) {
      // reOpen New Tab after click on yes button
      if (reOpenNewTab) {
        const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
        setReOpenNewTab(false);
        const navigationObj = updateTabs?.find((x) => {
          return x.redirectURLObj?.perviousNavTo;
        });
        // console.log('=== navigationObj ===', navigationObj);
        if (navigationObj) {
          const destination = {
            invoiceNum: navigationObj.redirectURLObj?.invoiceNum,
            checkLogNum: navigationObj.redirectURLObj?.checkLogNum,
            nextTabRoute: navigationObj?.nextRoute,
            nextTabTitle: navigationObj?.nextTabTitle,
          };
          if (destination.invoiceNum && destination.checkLogNum) {
            const tempObj = updateTabs.map((item) => {
              if (item === navigationObj) {
                item.redirectURLObj = {};
                item.closeTab = true;
              }
              return item;
            });
            localStorage.setItem('tabItemsData', JSON.stringify(tempObj));
            dispatch(
              dispatchAllocatePaymentHederData(
                {
                  ...(headerAllocatePaymentData[
                    `${activeInvNum}-${activeCheckLogNum}`
                  ].closeTab = true),
                },
                activeInvNum,
                activeCheckLogNum
              )
            );
            (async () => {
              try {
                await masterDataSaveAndClose(undefined, {
                  invoiceNum: destination.invoiceNum,
                  checkLogNum: destination.checkLogNum,
                });
              } catch (e) {
                console.error('Save/close sequence error', e);
              } finally {
                handleClearReduxData(activeInvNum, activeCheckLogNum);
                closeTab(
                  `/allocatePaymentDetail/${destination.checkLogNum}-${destination.invoiceNum}`,
                  history
                );
                redirectURLLink(
                  destination.nextTabRoute,
                  destination.nextTabTitle,
                  history,
                  dispatch
                );
              }
            })();
          }
        }
      } else {
        masterDataSaveAndClose(
          addEditAllocatePaymentDetailAllScreenObj[
            `${activeInvNum}-${activeCheckLogNum}`
          ]?.tabValue
        );
        let storeData = deallocateNdcRosi;
        storeData = {
          ...storeData,
          [`${activeInvNum}-${activeCheckLogNum}`]: [],
        };
        dispatch(deallocateNDCStore(storeData));
        let storeData1 = deallocateNdcPqas;
        storeData1 = {
          ...storeData1,
          [`${activeInvNum}-${activeCheckLogNum}`]: [],
        };
        dispatch(deallocateNdcPqasStore(storeData1));
        const tempObj = headerAllocatePaymentData;
        const tempObjFlag = { ...updateDetailsAllData };
        tempObjFlag[`${activeInvNum}-${activeCheckLogNum}`] = {
          ...tempObjFlag[`${activeInvNum}-${activeCheckLogNum}`],
          flag: true,
        };
        dispatch(setUpdateDetails(tempObjFlag));
        if (allocateFlag) {
          handleScrollToEvent();
          tempObj[
            `${activeInvNum}-${activeCheckLogNum}`
          ].allocationCompleteInd = 1;
          setAllocateDetailObj({
            ...allocateDetailObj,
            allocationCompleteInd: 1,
          });
        }
        if (
          handleTabValue &&
          (!discrepancyAlert ||
            saveDetailApiResponse?.data?.apiResponse === 'Save Bypass Update' ||
            saveDetailApiResponse?.data?.apiResponse === 'Successfully Saved')
        ) {
          closeTab(
            `/allocatePaymentDetail/${allocatePaymentHeaderDetail?.checkLogNum}-${allocatePaymentHeaderDetail?.invoiceNum}`,
            history
          );
          dispatch(
            clearReduxAllocatePaymentThirdScreen(
              allocatePaymentHeaderDetail?.invoiceNum,
              allocatePaymentHeaderDetail?.checkLogNum,
              history
            )
          );
          closedRef.current = true;
        }
        dispatch(
          dispatchAllocatePaymentHederData(
            tempObj,
            activeInvNum,
            activeCheckLogNum
          )
        );
        let localErr = [];
        localErr = localErr?.filter(
          (item) => item.errorType !== 'errorMessage'
        );
        localErr = localErr?.filter(
          (item) => item.errorType !== 'SucessMessage'
        );
        localErr.push({
          field: 'SucessMessage',
          errorType: 'SucessMessage',
          message: constantMessageData.SUCCESSMESSAGE_GENERIC,
        });
        handleDisabledIntPaidStoreVal();
        // let activeInvNum
        const obj = { ...errorMessagesFromRedux?.detailScreenErrors };
        obj[`${activeInvNum}-${activeCheckLogNum}`] = localErr;

        dispatch(
          handleErrorMessageForAllocatePayment({
            detailScreenErrors: obj,
            searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
              ? errorMessagesFromRedux?.searchScreenErrors
              : [],
          })
        );
      }
    } else if (
      saveDetailApiResponse === 'discrepancy For NDC : 00002-1433-01 [RAUA]'
    ) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      if (updateTabs.length > 0) {
        updateTabs.forEach((item) => {
          setModalTitle(item.value);
        });
      }
      setWarningAlert(true);
      setWaringMessage(constantMessageData.DISCREPANCY_FOR_NDC);
    } else if (saveDetailApiResponse.length === 0) {
      let localErr =
        errorMessagesFromRedux?.detailScreenErrors[
          `${activeInvNum}-${activeCheckLogNum}`
        ] || [];
      localErr = localErr?.filter((item) => item.errorType !== 'errorMessage');
      localErr = localErr?.filter((item) => item.errorType !== 'SucessMessage');
      localErr.push({
        field: 'failedMessage',
        errorType: 'errorMessage',
        message: constantMessageData.FAIL_PROCESSING_REQUEST,
      });
      // let activeInvNum
      const obj = { ...errorMessagesFromRedux?.detailScreenErrors };
      obj[`${activeInvNum}-${activeCheckLogNum}`] = localErr;

      dispatch(
        handleErrorMessageForAllocatePayment({
          detailScreenErrors: obj,
          searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
            ? errorMessagesFromRedux?.searchScreenErrors
            : [],
        })
      );
      handleScrollToEvent();
      const tempObjFlag = { ...updateDetailsAllData };
      tempObjFlag[`${activeInvNum}-${activeCheckLogNum}`] = {
        ...tempObjFlag[`${activeInvNum}-${activeCheckLogNum}`],
        flag: false,
      };
      dispatch(setUpdateDetails(tempObjFlag));
    }
  }, [saveDetailApiResponse]);
  React.useEffect(() => {
    if (flag1 && flag2) {
      closeTab(
        `/allocatePaymentDetail/${allocatePaymentHeaderDetail?.checkLogNum}-${allocatePaymentHeaderDetail?.invoiceNum}`,
        history
      );
    }
  }, [flag1, flag2]);

  React.useEffect(() => {
    if (!disabledSaveCancelBtn) {
      let localErr =
        errorMessagesFromRedux?.detailScreenErrors?.[
          `${activeInvNum}-${activeCheckLogNum}`
        ] || [];
      localErr = localErr?.filter((item) => item.errorType !== 'errorMessage');
      localErr = localErr?.filter((item) => item.errorType !== 'SucessMessage');

      // let activeInvNum
      const obj = { ...errorMessagesFromRedux?.detailScreenErrors };
      obj[`${activeInvNum}-${activeCheckLogNum}`] = localErr;

      dispatch(
        handleErrorMessageForAllocatePayment({
          detailScreenErrors: obj,
          searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
            ? errorMessagesFromRedux?.searchScreenErrors
            : [],
        })
      );
    }
  }, [disabledSaveCancelBtn]);

  // store Value In Redux for Disable Int.paid Column
  const handleDisabledIntPaidStoreVal = () => {
    const newObjPQAS1 = disabledIntPaidAllPQAS;
    newObjPQAS1[`${activeInvNum}-${activeCheckLogNum}`] = {
      ...singleDisabledIntPaidColObjPqas,
      isSave: true,
    };
    dispatch(setDisabledValIntPaidPQAS(newObjPQAS1));
    const disabledIntPaidObj1 = { ...disabledIntPaidAllROSI };
    disabledIntPaidObj1[`${activeInvNum}-${activeCheckLogNum}`] = {
      ...singleDisabledIntPaidColObjRosi,
      isSave: true,
    };
    dispatch(setDisabledValIntPaid(disabledIntPaidObj1));
  };
  // handle discrepancy warning alert function call
  const handleDiscrepancyWarningAlert = async (data, PQASData) => {
    let status = null;
    setDiscrepancyAlert(false);

    if (data?.length > 0 || PQASData?.length > 0) {
      const errorMsg = [];
      if (data?.length > 0) {
        const obj = data?.map((item) => {
          let adjCds = '';
          if (item.ccAc1 !== '-1' && item.ccAc1 !== null) {
            adjCds += item.ccAc1;
          }
          if (item.ccAc2 !== '-1' && item.ccAc2 !== null) {
            adjCds += item.ccAc2;
          }
          if (item.ccAc3 !== '-1' && item.ccAc3 !== null) {
            adjCds += item.ccAc3;
          }
          let disputeCds = '';
          if (item.ccDc1 !== '-1' && item.ccDc1 !== null) {
            disputeCds += item.ccDc1;
          }
          if (item.ccDc2 !== '-1' && item.ccDc2 !== null) {
            disputeCds += item.ccDc2;
          }
          if (item.ccAc3 !== '-1' && item.ccAc3 !== null) {
            disputeCds += item.ccAc3;
          }
          return {
            ndc: removeWhiteSpaceForNDC(item.ndc),
            adjustedUnitsIsUpdate: item.adjustedUnitsIsUpdate,
            adjustedUnitRebateAmtIsUpdate: item.adjustedUnitRebateAmtIsUpdate,
            userName: logInUserID,
            userId: logInUserID,
            dataSource: 'APP',
            fileSeqNum: 0,
            setSeqNum: 0,
            recordSeqNum: 0,
            rosiQtr: item.qtr,
            labelerCode: item.labelerCode,
            productCode: item.productCode,
            packageSize: item.packageSize,
            unitRebateAmt: parseFloat(
              replaceCommaIntoWhiteSpace(item.unitRebateAmt)
            ),
            adjustedUnitRebateAmt: item.adjustedUnitRebateAmt
              ? parseFloat(
                  replaceCommaIntoWhiteSpace(item.adjustedUnitRebateAmt)
                )
              : item.adjustedUnitRebateAmt,
            numOfUnits: parseFloat(
              replaceCommaIntoWhiteSpace(item.totReimbursedUnits)
            ),
            totReimbursedUnits: parseFloat(
              replaceCommaIntoWhiteSpace(item.totReimbursedUnits)
            ),
            adjustedUnits: parseFloat(
              replaceCommaIntoWhiteSpace(item.adjustedUnits)
            ),
            disputedUnits: parseFloat(
              replaceCommaIntoWhiteSpace(item.disputedUnits)
            ),
            paidUnits: parseFloat(replaceCommaIntoWhiteSpace(item.paidUnits)),
            invoiceAmt: parseFloat(replaceCommaIntoWhiteSpace(item.invoiceAmt)),
            invoiceCorrectionAmt: roundOffInvoiceCorrectionAmt(item),
            withheldInvoiceAmt: roundOffWithheldInvcAmount(item),
            paidAmt: roundOffPaidAmount(item),
            invoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
            setLabelerCode: item.labelerCode,
            checkPayeeCd: fetchSearchScreenData?.selectedRow?.checkPayeeCdVal,
            overrideInd: null,
            adjCode1: item.ccAc1 !== '-1' ? item.ccAc1 : null,
            adjCode2: item.ccAc2 !== '-1' ? item.ccAc2 : null,
            adjCode3: item.ccAc3 !== '-1' ? item.ccAc3 : null,
            dispCode1: item.ccDc1 !== '-1' ? item.ccDc1 : null,
            dispCode2: item.ccDc2 !== '-1' ? item.ccDc2 : null,
            dispCode3: item.ccDc3 !== '-1' ? item.ccDc3 : null,
            adjCds: adjCds,
            disputeCds: disputeCds,
          };
        });
        const result = await dispatch(getDiscrepanciesList(obj));
        status = result;
        if (result?.apiResponse?.length > 0) {
          result.apiResponse
            .filter((x) => {
              return !x.exitMessage && x.ndc;
            })
            .map((item) => {
              if (item.discrepencyCodes?.length > 0) {
                let ndcName = removeWhiteSpaceForNDC(item.ndc);
                const newObj = [];
                if (
                  parseInt(allocatePaymentHeaderDetail?.alisComm, [0, 1]) === 0
                ) {
                  const temp = removeWhiteSpaceForNDC(item.ndc)?.split('-');
                  if (temp?.length > 2) {
                    ndcName = `${temp[1]}-${temp[2]}`;
                  }
                }
                const rowIndex = ROSIGridRowData?.sort((a, b) =>
                  a.ndc > b.ndc ? 1 : -1
                )?.findIndex((x) => {
                  return removeWhiteSpaceForNDC(x.ndc) === ndcName;
                });
                item.discrepencyCodes.map((err) => {
                  newObj.push(setErrorMessageForDiscrepancy(err));
                  return err;
                });
                // setDiscrepancyCodes( item.discrepencyCodes)
                errorMsg.push({
                  gridName: 'ROSI',
                  title: `Discrepancies for row ${
                    rowIndex + 1
                  } NDC ${ndcName}.`,
                  errorMessagesList: [...new Set(newObj)],
                });
              }
              return item;
            });
        }
      }

      if (PQASData?.length > 0) {
        const obj1 = {
          prevQtr: pqasGridLevelActions?.pgQtrVal,
          pqasGridReqVo: PQASData?.map((item) => {
            let adjCds = '';
            if (item.ccAc1 !== '-1' && item.ccAc1 !== null) {
              adjCds += item.ccAc1;
            }
            if (item.ccAc2 !== '-1' && item.ccAc2 !== null) {
              adjCds += item.ccAc2;
            }
            if (item.ccAc3 !== '-1' && item.ccAc3 !== null) {
              adjCds += item.ccAc3;
            }
            let disputeCds = '';
            if (item.ccDc1 !== '-1' && item.ccDc1 !== null) {
              disputeCds += item.ccDc1;
            }
            if (item.ccDc2 !== '-1' && item.ccDc2 !== null) {
              disputeCds += item.ccDc2;
            }
            if (item.ccAc3 !== '-1' && item.ccAc3 !== null) {
              disputeCds += item.ccAc3;
            }
            return {
              ndc: removeWhiteSpaceForNDC(item.ndc),
              ccPaidInFullInd: item.ccPaidInFullInd,
              ccRowSource: item.ccRowSource,
              corrLinkId: item?.corrLinkId,
              ccCommentsExist: item?.ccCommentsExist,
              pqiddrugSeqNum: item.pqiddrugSeqNum,
              drugName: item.drugName,
              drugSeqNum: item.drugSeqNum,
              invStatusCd: '',
              checkReceivedDt: '',
              interestSettledInd: item?.interestSettledInd,
              isModifiedCurrUnitsDisputedColumn:
                !!item?.isModifiedCurrUnitsDisputedColumn,
              isRecordModifiedOrNew: !!item?.isRecordModifiedOrNew,
              labelerCode: item?.labelerCode,
              numOfPrescriptions: item?.numOfPrescriptions,
              numOfUnits: item?.numOfUnits,
              numOfUnitsOutstanding: item?.numOfUnitsOutstanding,
              packageSize: item?.packageSize,
              userName: logInUserID,
              userId: logInUserID,
              checkPayeeCd: fetchSearchScreenData?.selectedRow?.checkPayeeCdVal,
              overrideInd: null,
              ccAc1: item.ccAc1 !== '-1' ? item.ccAc1 : null,
              ccAc2: item.ccAc2 !== '-1' ? item.ccAc2 : null,
              ccAc3: item.ccAc3 !== '-1' ? item.ccAc3 : null,
              ccDc1: item.ccDc1 !== '-1' ? item.ccDc1 : null,
              ccDc2: item.ccDc2 !== '-1' ? item.ccDc2 : null,
              ccDc3: item.ccDc3 !== '-1' ? item.ccDc3 : null,
              // adjCds: adjCds,
              // disputeCds: disputeCds,

              ccInterestAllocated: parseFloat(
                replaceCommaIntoWhiteSpace(item.ccInterestAllocated)
              ),
              cidunitRebateAmt: parseFloat(
                replaceCommaIntoWhiteSpace(item.cidunitRebateAmt || 0)
              ),
              cinterestCalculated: parseFloat(
                replaceCommaIntoWhiteSpace(item.cinterestCalculated || 0)
              ),
              currAmtPaid: roundOffCurrMatPaidAmount(item),
              currUnitRebateAmt: parseFloat(
                replaceCommaIntoWhiteSpace(item.currUnitRebateAmt || 0)
              )?.toFixed(6),
              currUnits: parseFloat(
                replaceCommaIntoWhiteSpace(item.currUnits || 0)
              )?.toFixed(3),
              currUnitsDisputed: item.currUnitsDisputed
                ? parseFloat(
                    replaceCommaIntoWhiteSpace(item.currUnitsDisputed || 0)
                  )
                : null,
              currUnitsPaid: parseFloat(
                replaceCommaIntoWhiteSpace(item.currUnitsPaid || 0)
              ),
              paidThisTransactionAmt:
                roundOffPaidThisTransactionAmtAmount(item),
              paidUnits: parseFloat(
                replaceCommaIntoWhiteSpace(item?.paidUnits || 0)
              ),
              pqasDrugCurrUnitsDisputed: parseFloat(
                replaceCommaIntoWhiteSpace(item?.pqasDrugCurrUnitsDisputed)
              ),
              pqidinvoiceNum: parseFloat(
                replaceCommaIntoWhiteSpace(item?.pqidinvoiceNum)
              ),
              pqidnumOfUnits: parseFloat(
                replaceCommaIntoWhiteSpace(item?.pqidnumOfUnits)
              ),
              pqidpriorPaidAmt: parseFloat(
                replaceCommaIntoWhiteSpace(item?.pqidpriorPaidAmt)
              )?.toFixed(2),
              pqidunitRebateAmt: parseFloat(
                replaceCommaIntoWhiteSpace(item?.pqidunitRebateAmt)
              ),
              priorDisputedUnits: parseFloat(
                replaceCommaIntoWhiteSpace(item?.priorDisputedUnits)
              ),
              priorPaidAmt: roundOffPriorPaidAmtAmount(item),
              priorPaidUnits: parseFloat(
                replaceCommaIntoWhiteSpace(item?.priorPaidUnits)
              ),
              productCode: item?.productCode,
              revisedInvoiceAmt: roundOffRevisedInoiveAmount(item),
              statusCd: '',
              totReimbursedAmt: roundOffTotReimbursedAmt(item),
              totReimbursedUnits: parseFloat(
                replaceCommaIntoWhiteSpace(item?.totReimbursedUnits)
              ),
              updateDqdInd: item?.updateDqdInd,
              xorigAmtPtt: roundOffXorigAmtPttAmount(item),
              xorigCurrUnitsDisputed: parseFloat(
                replaceCommaIntoWhiteSpace(item?.xorigCurrUnitsDisputed)
              ),
              xorigCurrUnitsPaid: parseFloat(
                replaceCommaIntoWhiteSpace(item?.xorigCurrUnitsPaid)
              ),
              xorigUnits: parseFloat(
                replaceCommaIntoWhiteSpace(item?.xorigUnits)
              ),
              xorigUra: parseFloat(replaceCommaIntoWhiteSpace(item?.xorigUra)),
            };
          }),
        };

        const result1 = await dispatch(getPQASTabDiscrepanciesList(obj1));
        if (result1?.validatePqasResponse?.length > 0) {
          result1.validatePqasResponse
            .filter((x) => {
              return !x.exitMessage && x.ndc;
            })
            .map((item) => {
              if (item.discrepencyCodes?.length > 0) {
                const newObj1 = [];
                let ndcName = removeWhiteSpaceForNDC(item.ndc);
                if (
                  parseInt(allocatePaymentHeaderDetail?.alisComm, [0, 1]) === 0
                ) {
                  const temp = removeWhiteSpaceForNDC(item.ndc)?.split('-');
                  if (temp?.length > 2) {
                    ndcName = `${temp[1]}-${temp[2]}`;
                  }
                }
                const rowIndex = pqasGridData
                  ?.sort((a, b) => (a.ndc > b.ndc ? 1 : -1))
                  ?.findIndex((x) => {
                    return removeWhiteSpaceForNDC(x.ndc) === ndcName;
                  });
                item.discrepencyCodes.map((err) => {
                  newObj1.push(setErrorMessageForPQASDiscrepancy(err));
                  return err;
                });
                errorMsg.push({
                  gridName: 'PQAS',
                  title: `Discrepancies for row ${
                    rowIndex + 1
                  } NDC ${ndcName}.`,
                  errorMessagesList: [...new Set(newObj1)],
                });
              }
              return item;
            });
        }
      }

      //handleScrollToEvent();
      setDiscrepancyMsg(errorMsg);
      setDiscrepancyAlert(errorMsg.length > 0);
    }
    return status;
  };

  const saveAllocateDetail = async (params, activeRow, suspendedDate) => {
    const finalSuspendedDate =
      suspendedDate !== undefined
        ? suspendedDate
        : params === 'declareCheckAllocated'
        ? moment().format('MM/DD/YYYY')
        : null;
    dispatchSaveDetailsResponse('');
    dispatch(dispatchColIdForPqas(''));
    let saveResponse = {};
    let deAllocateNDCAmt = 0;
    if (params === 'DeallocateNDC') {
      // const deAllocateNdcRow = deAllocateNdcRosi;
      // const totalAmount = deAllocateNdcRow?.filter(
      //   (x) => x.id === activeRow?.id
      // )[0]?.changeAmt;
      // deAllocateNDCAmt = parseFloat(
      //   parseFloat(allocatePaymentHeaderDetail?.totAllocatedAmt || 0) -
      //     parseFloat(totalAmount || 0)
      // ).toFixed(2);
      deAllocateNDCAmt = calculateAllocateAmount('ROSI', activeRow);
    }
    if (params === 'DeallocateNDCPQAS') {
      const deAllocateNdcRow = deallocateNdcPqas;
      const totalAmount = deAllocateNdcRow?.filter(
        (x) => x.id === activeRow?.id
      )[0]?.changeAmt;

      deAllocateNDCAmt = parseFloat(
        parseFloat(allocatePaymentHeaderDetail?.totAllocatedAmt || 0) -
          parseFloat(totalAmount || 0)
      ).toFixed(2);
      calculateAllocateAmount('PQAS', activeRow);
    }
    // Call Discrepancy API call
    // Filter the ROSIGridRowData and pqasGridData arrays based on their conditions
    const filteredROSI = ROSIGridRowData?.filter(
      (x) => x.isRecordModifiedOrNew
    );
    const filteredPQAS = pqasGridData?.filter((x) => x.addEditRow);
    let result;
    if (discrepancyNDCsData?.length === 0) {
      // If discrepancyNDCsData is empty, just call handleDiscrepancyWarningAlert as-is
      result = await handleDiscrepancyWarningAlert(filteredROSI, filteredPQAS);
    } else {
      // If discrepancyNDCsData is not empty, we need to remove matching NDCs
      // Remove matching NDCs from ROSIGridRowData
      const updatedROSI = filteredROSI?.filter(
        (rosi) =>
          !discrepancyNDCsData.some(
            (discrepancy) =>
              removeWhiteSpaceForNDC(discrepancy.ndc) ===
              removeWhiteSpaceForNDC(rosi.ndc)
          )
      );
      // Remove matching NDCs from pqasGridData
      const updatedPQAS = filteredPQAS.filter(
        (pqas) =>
          !discrepancyNDCsData.some(
            (discrepancy) =>
              removeWhiteSpaceForNDC(discrepancy.ndc) ===
              removeWhiteSpaceForNDC(pqas.ndc)
          )
      );
      // Call handleDiscrepancyWarningAlert with updated lists
      result = await handleDiscrepancyWarningAlert(updatedROSI, updatedPQAS);
    }
    if (result === null) {
      let localErr =
        errorMessagesFromRedux?.detailScreenErrors[
          `${activeInvNum}-${activeCheckLogNum}`
        ] || [];
      localErr = localErr?.filter((item) => item.errorType !== 'errorMessage');
      localErr = localErr?.filter((item) => item.errorType !== 'SucessMessage');
      // localErr.push({
      //   field: 'failedMessage',
      //   errorType: 'errorMessage',
      //   message: constantMessageData.FAIL_PROCESSING_REQUEST,
      // });

      // let activeInvNum
      const obj = { ...errorMessagesFromRedux?.detailScreenErrors };
      obj[`${activeInvNum}-${activeCheckLogNum}`] = localErr;

      dispatch(
        handleErrorMessageForAllocatePayment({
          detailScreenErrors: obj,
          searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
            ? errorMessagesFromRedux?.searchScreenErrors
            : [],
        })
      );
      handleScrollToEvent();
      const tempObjFlag = { ...updateDetailsAllData };
      tempObjFlag[activeInvNum] = { ...tempObjFlag[activeInvNum], flag: true };
      dispatch(setUpdateDetails(tempObjFlag));
    }
    const findIndx = pqasGridData?.findIndex((item) => {
      return item?.invRecSeqNum !== null;
    });
    let pqasGridDataNew =
      pqasGridData !== undefined && pqasGridData.length > 0
        ? pqasGridData
            ?.filter((item) => item.addEditRow || item.addEditRowSummary)
            ?.map((item) => {
              return {
                ...item,
                invStatusCd: getPreInitData?.invoiceStatusCd,
                checkReceivedDt: allocatePaymentHeaderDetail?.receivedDt
                  ? moment(allocatePaymentHeaderDetail?.receivedDt).format(
                      'MM/DD/YYYY'
                    )
                  : null,
              };
            })
        : [];
    if (pqasGridDataNew.length != 0) {
      if (stringDeallocateRowNums != '') {
        const deallocateRowNumbers = stringDeallocateRowNums
          .split(',')
          .map(Number);
        pqasGridDataNew = pqasGridDataNew.filter(
          (item) =>
            !deallocateRowNumbers.includes(item.currUnitsDisputedRowNumber)
        );
      }
      const grouped = new Map();
      pqasGridDataNew.forEach((item) => {
        if (!grouped.has(removeWhiteSpaceForNDC(item.ndc))) {
          grouped.set(removeWhiteSpaceForNDC(item.ndc), []);
        }
        grouped.get(removeWhiteSpaceForNDC(item.ndc)).push(item);
      });
      const removeDuplicateNDC = [];
      grouped.forEach((items) => {
        const filteredItems = items.filter(
          (item) => item.bgColorForNDC !== '11534335'
        );
        if (filteredItems.length === 0) {
          removeDuplicateNDC.push(items[0]);
        } else {
          removeDuplicateNDC.push(...filteredItems);
        }
      });
      pqasGridDataNew = removeDuplicateNDC;
    }
    let addNDCOrDuplicateNDCCOunt = 0;
    if (deAllocateNdcPqas?.length > 0) {
      deAllocateNdcPqas.forEach((item) => {
        if (
          addOrDuplicateNDCSingle?.filter(
            (x) => x.drugSeqNum == item.drugSeqNum
          )?.length > 0
        ) {
          addNDCOrDuplicateNDCCOunt += 1;
        }
      });
    }
    const rosiGridDataNew =
      ROSIGridRowData !== undefined && ROSIGridRowData.length > 0
        ? ROSIGridRowData?.filter((item) => item.isRecordModifiedOrNew)?.map(
            (item) => {
              const il_RPSN = allocatePaymentHeaderDetail?.recancilationNumber
                ? allocatePaymentHeaderDetail?.recancilationNumber
                : allocatePaymentHeaderDetail?.reconciliationNumber;
              const ll_OtherRPSN = item.invRecSeqNum;
              let isPaidByDifCheck = false;
              if (ll_OtherRPSN && ll_OtherRPSN !== 0) {
                if (ll_OtherRPSN !== il_RPSN) {
                  isPaidByDifCheck = true;
                }
              }
              return {
                ...item,
                isPaidByDifCheck: isPaidByDifCheck,
              };
            }
          )
        : [];
    const updatedInvBalAdjust =
      tabValue === 'one'
        ? parseFloat(
            summaryGridReduxData?.[0]?.principalPaid
              .toString()
              .replace('$', '')
              .replaceAll(',', '')
              .trim()
          ) -
          parseFloat(
            summaryGridReduxData?.[0]?.orgPrincipalPaid
              .toString()
              .replace('$', '')
              .replaceAll(',', '')
              .trim()
          )
        : parseFloat(
            pqasSummaryGridList?.[0]?.principalPaidThisCheck
              .toString()
              .replace('$', '')
              .replaceAll(',', '')
              .trim()
          ) -
          parseFloat(
            pqasSummaryGridList?.[0]?.orgPrincipalPaidThisCheck
              .toString()
              .replace('$', '')
              .replaceAll(',', '')
              .trim()
          );
    const reconciliationNumber =
      allocatePaymentHeaderDetail?.reconciliationNumber;
    const totalUnmatched = pqasGridDataNew
      ?.filter(
        (item) => item.invRecSeqNum !== reconciliationNumber && item.addEditRow
      ) // keep only unmatched
      .reduce((sum, item) => sum + Number(item.paidThisTransactionAmt), 0); // sum amounts
    saveResponse = dispatch(
      saveAllocatePaymentDetails({
        rosiDeallocateVo:
          deAllocateNdcRosi?.length > 0
            ? deAllocateNdcRosi?.map((item) => {
                delete item.id;
                return item;
              })
            : [],
        pqasDeallocateVo:
          deAllocateNdcPqas?.length > 0
            ? deAllocateNdcPqas?.map((item) => {
                delete item.id;
                return item;
              })
            : [],
        allocationComplete: params === 'declareCheckAllocated' ? true : false,
        allocationCompleteValue: params === 'declareCheckAllocated' ? 1 : 0,
        asQtr: handleQuarterFormate(allocatePaymentHeaderDetail?.qtr),
        asRpc: allocatePaymentHeaderDetail?.rebateProgramCd,
        asStatusCd: '',
        checkAmt: parseFloat(
          replaceCommaIntoWhiteSpace(allocateDetailObj?.checkAmt)
        )?.toFixed(2),
        checkLogNum: allocatePaymentHeaderDetail?.checkLogNum,
        checkPayeeCd:
          fetchSearchScreenData?.state?.allocateFrom === 'Check'
            ? fetchSearchScreenData?.selectedRow?.checkPayeeCdVal
            : 'ALL',
        recancilationNum:
          allocatePaymentHeaderDetail?.recancilationNumber === null
            ? 0
            : allocatePaymentHeaderDetail?.recancilationNumber,
        discrepencyCodes: [],
        // discrepencyCodes: result?.apiResponse?.filter(
        //   (item) => item?.ndc !== null
        // ),
        headerVO: {
          allocationCompleteInd: params === 'declareCheckAllocated' ? 1 : 0,
          checkAmt: parseFloat(
            replaceCommaIntoWhiteSpace(allocateDetailObj?.checkAmt)
          )?.toFixed(2),
          checkDt: allocatePaymentHeaderDetail?.checkDt
            ? moment(allocatePaymentHeaderDetail?.checkDt).format('MM/DD/YYYY')
            : null,
          contractSeqNum: allocatePaymentHeaderDetail?.contractSeqNum,
          dispqtr: allocatePaymentHeaderDetail?.dispqtr,
          invoiceBalance: allocatePaymentHeaderDetail?.invoiceBalance,
          invoiceCreateDt: allocatePaymentHeaderDetail?.invoiceCreateDt
            ? moment(allocatePaymentHeaderDetail?.invoiceCreateDt).format(
                'MM/DD/YYYY'
              )
            : null,
          invoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
          mfgId: allocatePaymentHeaderDetail?.mfgId,
          mfgName: allocatePaymentHeaderDetail?.mfgName,
          postmarkedDt: allocatePaymentHeaderDetail?.postmarkedDt
            ? moment(allocatePaymentHeaderDetail?.postmarkedDt).format(
                'MM/DD/YYYY'
              )
            : null,
          qtr: handleQuarterFormate(allocatePaymentHeaderDetail?.qtr),
          rebateProgramCd: allocatePaymentHeaderDetail?.rebateProgramCd,
          receivedDt: allocatePaymentHeaderDetail?.receivedDt
            ? moment(allocatePaymentHeaderDetail?.receivedDt).format(
                'MM/DD/YYYY'
              )
            : null,
          suspendedDt: allocatePaymentHeaderDetail?.suspendedDt
            ? moment(allocatePaymentHeaderDetail?.suspendedDt).format(
                'MM/DD/YYYY'
              )
            : null,
          totAllocatedAmt: parseFloat(
            replaceCommaIntoWhiteSpace(
              params === 'DeallocateNDC' || params === 'DeallocateNDCPQAS'
                ? deAllocateNDCAmt
                : Number(allocateDetailObj.totAllocatedAmt) + totalUnmatched
            )
          ),
          totCurrQtrAmt: allocatePaymentHeaderDetail?.totCurrQtrAmt,
          totInformationalAmt: allocatePaymentHeaderDetail?.totInformationalAmt,
          totUnitChangesAmt: allocatePaymentHeaderDetail?.totUnitChangesAmt,
        },
        ilDeletedRows: addNDCOrDuplicateNDCCOunt || 0,
        invBalAdjust: roundOffAmt(updatedInvBalAdjust),
        invStatusCd: '',
        istrDeAlloc: 0,
        invoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
        lastUpdatedId: logInUserID,
        mfgId: allocatePaymentHeaderDetail?.mfgId,
        pqasGridRespList: [
          {
            currQTR: handleQuarterFormate(allocatePaymentHeaderDetail?.qtr),
            idecInvoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
            idecPrevInvoiceNum: !_.isEmpty(getInvoiceHeader)
              ? getInvoiceHeader?.postInitByInvoiceHeaderResp?.[0]
                  ?.idecPrevInvoiceNum
              : null,
            invRecSeqNum:
              getPreInitData?.invRecSeqNum === null
                ? pqasGridData[findIndx]?.invRecSeqNum
                : getPreInitData?.invRecSeqNum,
            pqasGridReqVo:
              pqasGridDataNew.length > 0
                ? pqasGridDataNew
                    ?.filter((item) => item.addEditRow)
                    .map((item) => {
                      return {
                        ccAc1:
                          item.ccAc1 !== undefined && item.ccAc1 !== '-1'
                            ? item.ccAc1
                            : '',
                        ccAc2:
                          item.ccAc2 !== undefined && item.ccAc2 !== '-1'
                            ? item.ccAc2
                            : '',
                        ccAc3:
                          item.ccAc3 !== undefined && item.ccAc3 !== '-1'
                            ? item.ccAc3
                            : '',
                        ccCommentsExist: item?.ccCommentsExist,
                        ccDc1:
                          item.ccDc1 !== undefined && item.ccDc1 !== '-1'
                            ? item.ccDc1
                            : '',
                        ccDc2:
                          item.ccDc2 !== undefined && item.ccDc2 !== '-1'
                            ? item.ccDc2
                            : '',
                        ccDc3:
                          item.ccDc3 !== undefined && item.ccDc3 !== '-1'
                            ? item.ccDc3
                            : '',
                        ccInterestAllocated: parseFloat(
                          item.ccInterestAllocated
                        )?.toFixed(2),
                        ccPaidInFullInd: item.ccPaidInFullInd,
                        ccRowSource: item.ccRowSource,
                        checkPayeeCd:
                          fetchSearchScreenData?.state?.allocateFrom === 'Check'
                            ? fetchSearchScreenData?.selectedRow
                                ?.checkPayeeCdVal
                            : 'ALL',
                        cidunitRebateAmt: item.cidunitRebateAmt
                          ? parseFloat(item.cidunitRebateAmt)?.toFixed(6)
                          : parseFloat(0)?.toFixed(6),
                        cinterestCalculated:
                          item.cinterestCalculated === null
                            ? 0
                            : parseFloat(item.cinterestCalculated).toFixed(2),
                        corrLinkId:
                          item.corrLinkId === 'new' ? 0 : item.corrLinkId,
                        currAmtPaid: item.currAmtPaid
                          ? parseFloat(item.currAmtPaid)?.toFixed(2)
                          : parseFloat(0)?.toFixed(2),
                        currUnitRebateAmt: item.currUnitRebateAmt
                          ? parseFloat(item.currUnitRebateAmt)?.toFixed(6)
                          : parseFloat(0)?.toFixed(6),
                        currUnits: item.currUnits
                          ? parseFloat(item.currUnits)?.toFixed(3)
                          : parseFloat(0)?.toFixed(3),
                        currUnitsDisputed:
                          item.currUnitsDisputed === null ||
                          item.currUnitsDisputed === '' ||
                          isNaN(item.currUnitsDisputed)
                            ? null
                            : parseFloat(item.currUnitsDisputed)?.toFixed(3),

                        currUnitsPaid: item.currUnitsPaid
                          ? parseFloat(item.currUnitsPaid)?.toFixed(3)
                          : parseFloat(0)?.toFixed(3),
                        discrepencyCodes: item.discrepencyCodes,
                        pqiddrugSeqNum: item.pqiddrugSeqNum,
                        drugName: item.drugName,
                        drugSeqNum: item.drugSeqNum,
                        invStatusCd: item.invStatusCd,
                        checkReceivedDt: item.checkReceivedDt,
                        interestSettledInd: item.interestSettledInd,
                        isModifiedCurrUnitsDisputedColumn:
                          !!item.isModifiedCurrUnitsDisputedColumn,
                        isRecordModifiedOrNew: true,
                        labelerCode: item.labelerCode,
                        numOfPrescriptions: item.numOfPrescriptions,
                        numOfUnits: item.numOfUnits,
                        numOfUnitsOutstanding: item.numOfUnitsOutstanding,
                        packageSize: item.packageSize,
                        paidThisTransactionAmt: item.paidThisTransactionAmt,
                        orgPaidThisTransactionAmt:
                          item.orgPaidThisTransactionAmt,
                        paidUnits: item.paidUnits,
                        pqasDrugCurrUnitsDisputed:
                          item.pqasDrugCurrUnitsDisputed,
                        pqidinvoiceNum: item.pqidinvoiceNum,
                        pqidnumOfUnits: item.pqidnumOfUnits,
                        pqidpriorPaidAmt: item.pqidpriorPaidAmt,
                        pqidunitRebateAmt: item.pqidunitRebateAmt,
                        priorDisputedUnits: item.priorDisputedUnits
                          ? parseFloat(item.priorDisputedUnits)?.toFixed(3)
                          : parseFloat(0)?.toFixed(3),
                        priorPaidAmt: item.priorPaidAmt
                          ? parseFloat(item.priorPaidAmt)?.toFixed(2)
                          : parseFloat(0)?.toFixed(2),
                        priorPaidUnits: item.priorPaidUnits
                          ? parseFloat(item.priorPaidUnits)?.toFixed(3)
                          : parseFloat(0)?.toFixed(3),
                        productCode: item.productCode,
                        revisedInvoiceAmt: item.revisedInvoiceAmt
                          ? parseFloat(item.revisedInvoiceAmt)?.toFixed(2)
                          : parseFloat(0)?.toFixed(2),
                        statusCd: item.statusCd,
                        statusDt: item.statusDt,
                        totReimbursedAmt: item.totReimbursedAmt,
                        totReimbursedUnits: item.totReimbursedUnits
                          ? parseFloat(item.revisedInvoiceAmt)?.toFixed(3)
                          : parseFloat(0)?.toFixed(3),
                        updateDqdInd: 1,
                        userName: logInUserID,
                        xorigAmtPtt: parseFloat(item.xorigAmtPtt),
                        xorigCurrUnitsDisputed: item.xorigCurrUnitsDisputed,
                        xorigCurrUnitsPaid: parseFloat(item.xorigCurrUnitsPaid),
                        xorigUnits: item.xorigUnits,
                        xorigUra: item.xorigUra,
                      };
                    })
                : [],
            prevInvoiceNum: !_.isEmpty(getInvoiceHeader)
              ? getInvoiceHeader?.postInitByInvoiceHeaderResp[0]
                  ?.idecPrevInvoiceNum
              : null,
            prevQtr: pqasGridLevelActions?.pgQtrVal,
            pqasSummaryGridResp: {
              interest_paid:
                pqasSummaryGridList?.[0]?.intPaidThisCheck === null
                  ? 0
                  : parseFloat(pqasSummaryGridList?.[0]?.intPaidThisCheck),
              lintPaid:
                parseFloat(pqasSummaryGridList?.[0]?.intPaidThisCheck) !== 0,

              llRPSN: allocatePaymentHeaderDetail?.reconciliationNumber,
              principal_paid: parseFloat(
                pqasSummaryGridList?.[0]?.principalPaidThisCheck
                  ?.toString()
                  ?.includes('$')
                  ? Number(
                      pqasSummaryGridList?.[0]?.principalPaidThisCheck
                        ?.replace('$', '')
                        ?.replaceAll(',', '')
                        ?.trim()
                    ) + totalUnmatched
                  : Number(
                      parseFloat(
                        pqasSummaryGridList?.[0]?.principalPaidThisCheck || 0
                      ).toFixed(2)
                    ) + totalUnmatched
              ),
            },
          },
        ],
        //: [],
        rosiGrid:
          rosiGridDataNew?.filter((x) => {
            return x.isRecordModifiedOrNew;
          }).length > 0
            ? rosiGridDataNew
                ?.filter((x) => {
                  return !x.isPaidByDifCheck;
                })
                ?.map((item) => {
                  const cleaned = replaceCommaIntoWhiteSpace(
                    item.unitRebateAmt
                  );
                  const parsed = parseFloat(cleaned);
                  const formattedUnitRebateAmt = isNaN(parsed)
                    ? '0.000000'
                    : parsed.toFixed(6);
                  return {
                    interestSettledInd: item.interestSettledInd,
                    drugSeqNum: item.drugSeqNum,
                    numOfUnits: parseFloat(
                      replaceCommaIntoWhiteSpace(item.totReimbursedUnits)
                    )?.toFixed(3),
                    labelerCode: item.labelerCode,
                    productCode: item.productCode,
                    packageSize: item.packageSize,
                    drugName: item.drugName,
                    unitRebateAmt: formattedUnitRebateAmt,
                    qtr: item.qtr,
                    adjustedUnitRebateAmt:
                      item.adjustedUnitRebateAmt === null ||
                      item.adjustedUnitRebateAmt === '' ||
                      isNaN(item.adjustedUnitRebateAmt) ||
                      (parseFloat(item.adjustedUnitRebateAmt)?.toString() ===
                        '0' &&
                        !item.adjustedUnitRebateAmtIsUpdate)
                        ? null
                        : parseFloat(
                            replaceCommaIntoWhiteSpace(
                              item.adjustedUnitRebateAmt
                            )
                          )?.toFixed(6),
                    totReimbursedUnits: parseFloat(
                      replaceCommaIntoWhiteSpace(item.totReimbursedUnits)
                    )?.toFixed(3),
                    adjustedUnits:
                      item.adjustedUnits === null ||
                      item.adjustedUnits === '' ||
                      isNaN(item.adjustedUnits) ||
                      (parseFloat(item.adjustedUnits)?.toString() === '0' &&
                        !item.adjustedUnitsIsUpdate)
                        ? null
                        : parseFloat(
                            replaceCommaIntoWhiteSpace(item.adjustedUnits)
                          )?.toFixed(3),
                    disputedUnits: parseFloat(
                      replaceCommaIntoWhiteSpace(item.disputedUnits)
                    )?.toFixed(3),
                    paidUnits: parseFloat(
                      replaceCommaIntoWhiteSpace(item.paidUnits)
                    )?.toFixed(3),
                    invoiceCorrectionAmt: parseFloat(
                      replaceCommaIntoWhiteSpace(item.invoiceCorrectionAmt)
                    )?.toFixed(2),
                    withheldInvoiceAmt: parseFloat(
                      replaceCommaIntoWhiteSpace(item.withheldInvoiceAmt)
                    )?.toFixed(2),
                    paidAmt: parseFloat(
                      replaceCommaIntoWhiteSpace(item.paidAmt)
                    )?.toFixed(2),
                    rosiDrugSeqNum: item.rosiDrugSeqNum,
                    invoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
                    invoiceQtr: item.invoiceQtr,
                    rosiPqasQtr: item.rosiPqasQtr,
                    invRecSeqNum: item.invRecSeqNum,
                    corrLinkId: item.corrLinkId === 'new' ? 0 : item.corrLinkId,
                    statusCd: item.statusCd,
                    roiDrugStatusDt: item.roiDrugStatusDt,
                    ccCommentsExist: item.ccCommentsExist,
                    ccPaidInFullInd: item.ccPaidInFullInd,
                    ccInterestOwed: parseFloat(item.ccInterestOwed).toFixed(2),
                    cInterestCalc:
                      item.cInterestCalc === undefined
                        ? 0
                        : parseFloat(item.cinterestCalc).toFixed(2),
                    ccInterestAllocated: item.addedAsNew
                      ? replaceHyphenWithZero(item.ccInterestAllocatedCopy)
                      : replaceHyphenWithZero(item.ccInterestAllocated),
                    ccAc1:
                      item.ccAc1 !== undefined && item.ccAc1 !== '-1'
                        ? item.ccAc1
                        : '',
                    ccAc2:
                      item.ccAc2 !== undefined && item.ccAc2 !== '-1'
                        ? item.ccAc2
                        : '',
                    ccAc3:
                      item.ccAc3 !== undefined && item.ccAc3 !== '-1'
                        ? item.ccAc3
                        : '',
                    ccDc1:
                      item.ccDc1 !== undefined && item.ccDc1 !== '-1'
                        ? item.ccDc1
                        : '',
                    ccDc2:
                      item.ccDc2 !== undefined && item.ccDc2 !== '-1'
                        ? item.ccDc2
                        : '',
                    ccDc3:
                      item.ccDc3 !== undefined && item.ccDc3 !== '-1'
                        ? item.ccDc3
                        : '',
                    ccRowSource: item.ccRowSource,
                    origUra: item.origUra,
                    origAdjUra: item.origAdjUra,
                    origAdjUnits: item.origAdjUnits,
                    origDispUnits: item.origDispUnits,
                    origPaidUnits: item.origPaidUnits,
                    origPaidAmt: item.origPaidAmt,
                    ccOverrideColor: item.ccOverrideColor,
                    ccOverrideColorDis: item.ccOverrideColorDis,
                    userName: logInUserID,
                    invoiceAmt: item.invoiceAmt,
                    updateDqdInd:
                      item.updateDqdInd === null ? 0 : item.updateDqdInd,
                    isRecordModifiedOrNew: item.isRecordModifiedOrNew,
                    ndc: removeWhiteSpaceForNDC(item.ndc),
                    dqdura: item.dqdura,
                  };
                })
            : [],
        rowStatus: '',
        srvo:
          ROSIGridRowData?.filter((x) => {
            return x.isRecordModifiedOrNew;
          }).length > 0 || summaryGridReduxData?.[0]?.addEditIntPaid
            ? {
                interest_paid:
                  summaryGridReduxData &&
                  summaryGridReduxData.length != 0 &&
                  !isNaN(parseFloat(summaryGridReduxData?.[0]?.intPaid))
                    ? parseFloat(
                        parseFloat(summaryGridReduxData?.[0].intPaid).toFixed(2)
                      )
                    : 0,
                lintPaid: summaryGridReduxData?.[0]?.disabledForIntPaid,
                llRPSN: allocatePaymentHeaderDetail?.reconciliationNumber,
                principal_paid: parseFloat(
                  summaryGridReduxData?.[0]?.principalPaid
                    .replace('$', '')
                    .replaceAll(',', '')
                    .trim()
                ),
              }
            : null,
        suspendedDate: finalSuspendedDate,
        totAllocatedAmt:
          singleDisabledIntPaidColObjRosi?.rosiGridIntPaidColumnDisabled
            ? parseFloat(
                replaceCommaIntoWhiteSpace(
                  params === 'DeallocateNDC'
                    ? deAllocateNDCAmt
                    : Number(allocateDetailObj?.totAllocatedAmt) +
                        totalUnmatched
                )
              )
            : parseFloat(
                replaceCommaIntoWhiteSpace(
                  params === 'DeallocateNDC' || params === 'DeallocateNDCPQAS'
                    ? deAllocateNDCAmt
                    : Number(allocateDetailObj?.totAllocatedAmt) +
                        totalUnmatched
                )
              ),
        userName: logInUserID,
      })
    );
    saveResponse.then((item) => {
      dispatch(isHandleOkPayRem(''));
      setSaveApirespnse(item?.data?.apiResponse);
      dispatchSaveDetailsResponse(item?.data?.apiResponse);
      const newData = pqasPageChanges(pqasGridLevelAllActions, {
        pgQtrVal: pqasGridLevelActions?.pgQtrVal,
        prevNextRecord: true,
        prevNextVal: null,
      });
      dispatch(dispatchPQASGridLevelActions({ ...newData }));
      if (params === 'declareCheckAllocated') {
        handleCloseTab('declareCheckAllocated');
      }
      dispatch(dispatchDiscrepancyNDCs([]));
      dispatch(isHandleOkPayRem(false));
    });
  };

  // (allocate payment part3)
  const majorSave = async () => {
    await dispatch(
      noPaySuspended({
        invoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
        checkLogNumber: allocatePaymentHeaderDetail?.checkLogNum,
        totAllocatedAmt: allocatePaymentHeaderDetail.totAllocatedAmt,
        lastUpdatedId: logInUserID,
        userId: logInUserID,
        status: true,
      })
    );
    setSaveView(false);
  };

  // check duplicate checkLog Number and different invoice Number
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs?.filter((x) => {
        return x.isAlreadyExistCheck || x.isSave;
      })?.length > 0
    ) {
      updateTabs.map((item) => {
        if (item.isAlreadyExistCheck) {
          setModalTitle(item.value);
          item.isAlreadyExistCheck = false;
          setWarningAlert(true);
          setWaringMessage(constantMessageData.ALREADY_EXIST_CHECK_LOG_NUM_NAV);
        }
        if (item.isSave) {
          setOpen(true);
          item.isSave = false;
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  React.useEffect(() => {
    // let timeId = null;
    if (ROSIGridRowData?.length > 0 && tabValue === 'one') {
      const newObj = [];
      ROSIGridRowData.forEach((item) => {
        const obj = { ...item };
        if (
          (item.invRecSeqNum ===
            allocatePaymentHeaderDetail?.reconciliationNumber ||
            item.invRecSeqNum === 0) &&
          item.addEditRow
        ) {
          let oldRow = DuplicateROSIGridData?.filter((x) => x.id === obj.id)[0];
          if (!oldRow) {
            oldRow = {
              paidAmt: 0,
              ccInterestAllocated: 0,
            };
          }
          if (
            deAllocateNdcRosi?.filter((x) => x.id === item?.id)?.length > 0 &&
            parseFloat(item.paidAmt) === 0
          ) {
            obj.paidAmt = parseFloat(
              parseFloat(oldRow.paidAmt) -
                parseFloat(
                  deAllocateNdcRosi?.filter((x) => x.id === item?.id)[0]
                    ?.changeAmt
                )
            )?.toFixed(2);
          } else if (
            deAllocateNdcRosi?.filter((x) => x.id === item?.id)?.length > 0 &&
            parseFloat(item.paidAmt) > 0
          ) {
            obj.paidAmt = parseFloat(parseFloat(item.paidAmt))?.toFixed(2);
          } else if (parseFloat(oldRow.paidAmt) > parseFloat(item.paidAmt)) {
            if (parseFloat(item.paidAmt) < 0) {
              obj.paidAmt = parseFloat(
                parseFloat(item.paidAmt) - parseFloat(oldRow.paidAmt)
              )?.toFixed(2);
            } else {
              obj.paidAmt = parseFloat(
                parseFloat(oldRow.paidAmt) - parseFloat(item.paidAmt)
              )?.toFixed(2);
            }
          } else {
            obj.paidAmt = parseFloat(
              parseFloat(item.paidAmt) - parseFloat(oldRow.paidAmt)
            )?.toFixed(2);
          }
          obj.ccInterestAllocated = parseFloat(
            parseFloat(item.ccInterestAllocated) -
              parseFloat(oldRow.ccInterestAllocated)
          )?.toFixed(2);
          newObj.push(obj);
        }
      });
      const newObj1 = [];
      ROSIGridRowData.forEach((item) => {
        const obj = { ...item };
        if (item.addEditRow) {
          let oldRow = DuplicateROSIGridData?.filter((x) => x.id === obj.id)[0];
          if (!oldRow) {
            oldRow = {
              paidAmt: 0,
              ccInterestAllocated: 0,
            };
          }
          obj.ccInterestAllocated = parseFloat(
            parseFloat(item.ccInterestAllocated) -
              parseFloat(oldRow.ccInterestAllocated)
          )?.toFixed(2);

          newObj1.push(obj);
        }
      });
      //timeId = setTimeout(() => {
      const ccInterestAllocatedAmt =
        singleDisabledIntPaidColObjRosi?.summaryGirdIntPaidColumnDisabled
          ? calculateTotalSum('ccInterestAllocated', newObj1)
          : 0;
      const totalAmount = calculateTotalSum('paidAmt', newObj);
      const intPaidVal =
        !singleDisabledIntPaidColObjRosi?.summaryGirdIntPaidColumnDisabled
          ? isNaN(parseFloat(summaryGridReduxData[0]?.intPaid))
            ? 0
            : parseFloat(summaryGridReduxData[0]?.intPaid)
          : 0;
      const summaryIntPaid =
        singleDisabledIntPaidColObjRosi?.summaryGirdIntPaidColumnDisabled
          ? 0
          : parseFloat(intPaidVal || 0) -
            parseFloat(summaryGridReduxData[0]?.originalAmtIntPaid || 0);
      // console.log('summaryIntPaid', summaryIntPaid);
      const calCulateAmt = parseFloat(
        parseFloat(totalAmount || 0) +
          parseFloat(ccInterestAllocatedAmt || 0) +
          parseFloat(
            !allocatePaymentHeaderDetail?.isPQASScreen ||
              !pqasGridData?.filter((x) => x.addEditRow)?.length > 0
              ? allocatePaymentHeaderDetail?.originalTotAllocatedAmt
              : allocatePaymentHeaderDetail?.totAllocatedAmt
          )
      ).toFixed(2);
      // console.log('calCulateAmt of rosi allocate amount', calCulateAmt);
      const finalCalCulateAmt = parseFloat(
        parseFloat(calCulateAmt || 0) + parseFloat(summaryIntPaid || 0)
      ).toFixed(2);
      setAllocateDetailObj({
        ...allocatePaymentHeaderDetail,
        isROSIScreen: true,
        totAllocatedAmt: finalCalCulateAmt,
        originalTotAllocatedAmt: finalCalCulateAmt,
      });
      // }, 1000);
    }
    //return () => clearTimeout(timeId);
  }, [ROSIGridRowData || summaryGridReduxData]);

  // for pqas grid calculate total amount at heard level
  React.useEffect(() => {
    //let timeId = null;
    if (pqasGridData?.length > 0 && tabValue === 'two') {
      const newObj = [];
      pqasGridData.forEach((item) => {
        const obj = { ...item };
        if (
          (item.invRecSeqNum ===
            allocatePaymentHeaderDetail?.reconciliationNumber ||
            item.invRecSeqNum === 0) &&
          item.addEditRow
        ) {
          let oldRow = duplicatePQASGridData?.filter((x) => x.id === obj.id)[0];
          if (!oldRow) {
            oldRow = {
              paidThisTransactionAmt: 0,
            };
          }
          if (
            deAllocateNdcPqas?.filter((x) => x.id === item?.id)?.length > 0 &&
            parseFloat(item.paidThisTransactionAmt) === 0
          ) {
            obj.paidThisTransactionAmt = parseFloat(
              parseFloat(oldRow.paidThisTransactionAmt) -
                parseFloat(
                  deAllocateNdcPqas?.filter((x) => x.id === item?.id)[0]
                    ?.changeAmt
                )
            )?.toFixed(2);
          } else if (
            deAllocateNdcPqas?.filter((x) => x.id === item?.id)?.length > 0 &&
            parseFloat(item.paidThisTransactionAmt) > 0
          ) {
            obj.paidThisTransactionAmt = parseFloat(
              parseFloat(item.paidThisTransactionAmt)
            )?.toFixed(2);
          } else if (
            parseFloat(oldRow.paidThisTransactionAmt) >
            parseFloat(item.paidThisTransactionAmt)
          ) {
            if (parseFloat(item.paidThisTransactionAmt) >= 0) {
              obj.paidThisTransactionAmt = parseFloat(
                parseFloat(oldRow.paidThisTransactionAmt) -
                  parseFloat(item.paidThisTransactionAmt)
              )?.toFixed(2);
            } else {
              obj.paidThisTransactionAmt = parseFloat(
                item.paidThisTransactionAmt
              ).toFixed(2);
            }
          } else if (parseFloat(item.paidThisTransactionAmt) >= 0) {
            obj.paidThisTransactionAmt = parseFloat(
              parseFloat(item.paidThisTransactionAmt) -
                parseFloat(oldRow.paidThisTransactionAmt)
            )?.toFixed(2);
          } else {
            obj.paidThisTransactionAmt = parseFloat(
              item.paidThisTransactionAmt
            ).toFixed(2);
          }

          newObj.push(obj);
        }
      });
      //timeId = setTimeout(() => {
      const totalAmount = calculateTotalSum('paidThisTransactionAmt', newObj);
      // console.log('totalAmount of pqas paid this Transaction Amt', totalAmount);
      const calCulateAmt = parseFloat(
        parseFloat(totalAmount || 0) +
          parseFloat(
            !allocatePaymentHeaderDetail?.isROSIScreen ||
              !pqasGridData?.filter((x) => x.addEditRow)?.length > 0
              ? allocatePaymentHeaderDetail?.totAllocatedAmt
              : allocatePaymentHeaderDetail?.originalTotAllocatedAmt
          )
      ).toFixed(2);
      // console.log('calCulateAmt of pqas allocate amount', calCulateAmt);
      setAllocateDetailObj({
        ...allocatePaymentHeaderDetail,
        isPQASScreen: true,
        totAllocatedAmt: calCulateAmt,
        originalTotAllocatedAmt: calCulateAmt,
      });
      //}, 100);
    }
    if (
      parseFloat(allocatePaymentHeaderDetail?.totAllocatedAmt) ===
        parseFloat(allocatePaymentHeaderDetail?.checkAmt) &&
      allocatePaymentHeaderDetail?.allocationCompleteInd != 1 &&
      !isPopupCancelled
    ) {
      setSameAmountForCheck(true);
      setModalTitle(ROSI_PQAS_ALERT_TITLE);
      setWaringMessage(constantMessageData.ALLOCATE_AMT_CHECK_AMT_SAME_ERROR);
    }
    //return () => clearTimeout(timeId);
  }, [pqasGridData || pqasSummaryGridList]);

  // check if any comment add on particular ccCommentsExist value
  React.useEffect(() => {
    if (showComments) {
      const tempObj = headerAllocatePaymentData;
      if (commentsList?.length > 0) {
        tempObj[`${activeInvNum}-${activeCheckLogNum}`].ccCommentsExist = 1;
        setAllocateDetailObj({
          ...allocateDetailObj,
          ccCommentsExist: 1,
        });
      } else {
        tempObj[`${activeInvNum}-${activeCheckLogNum}`].ccCommentsExist = 0;
        setAllocateDetailObj({
          ...allocateDetailObj,
          ccCommentsExist: 0,
        });
      }
      dispatch(
        dispatchAllocatePaymentHederData(
          tempObj,
          activeInvNum,
          activeCheckLogNum
        )
      );
    }
  }, [commentsList]);

  React.useEffect(() => {
    if (summaryGridReduxData?.length > 0) {
      if (getIsHandleOkPayRem === false) {
        SummaryOnLoad();
      }
    }
  }, [getIsHandleOkPayRem]);
  // summary onload logic
  const SummaryOnLoad = () => {
    const uniqueDrugs = new Set();
    let totalAmtOwed = 0;
    const il_RPSN = allocatePaymentHeaderDetail.recancilationNumber;
    if (ROSIGridRowData && ROSIGridRowData.length > 0) {
      ROSIGridRowData.forEach((item) => {
        const ll_OtherRPSN = item.invRecSeqNum;
        if (ll_OtherRPSN && ll_OtherRPSN !== 0) {
          if (ll_OtherRPSN !== il_RPSN) {
            totalAmtOwed = null;
          }
        }
        const ndc = item?.ndc;
        const rebateAmntInvc = parseFloat(item.rebateAmtInvoice);
        if (!uniqueDrugs.has(ndc) && totalAmtOwed != null) {
          uniqueDrugs.add(ndc);
          totalAmtOwed += parseFloat(rebateAmntInvc);
        }
      });
    }
    const tempVal =
      parseFloat(rsAddValuesRowData?.idblCheckAmt) -
      parseFloat(rsAddValuesRowData?.idblCheckAllocAmt);
    if (
      parseFloat(totalAmtOwed)?.toFixed(2) &&
      parseFloat(rsAddValuesRowData?.idblInvCurrQtrBal)?.toFixed(2)
    ) {
      if (
        (parseFloat(totalAmtOwed)?.toFixed(2) ===
          parseFloat(rsAddValuesRowData?.idblInBal)?.toFixed(2) ||
          parseFloat(totalAmtOwed)?.toFixed(1) ===
            parseFloat(rsAddValuesRowData?.idblInBal)?.toFixed(1)) &&
        parseFloat(rsAddValuesRowData?.idblInBal)?.toFixed(2) ===
          parseFloat(rsAddValuesRowData?.idblInvCurrQtrBal)?.toFixed(2)
      ) {
        if (
          parseFloat(rsAddValuesRowData?.idblCheckAmt)?.toFixed(2) > 0 &&
          parseFloat(tempVal)?.toFixed(2) ===
            parseFloat(totalAmtOwed)?.toFixed(2)
        ) {
          setSummaryGridPopup(true);
          setSummaryGridMsg(constantMessageData.SUMMARY_GRID_MSG);
        }
      }
    }
  };
  const calculateAllocateAmount = (params, activeRow) => {
    const deAllocateNdcRow =
      params === 'ROSI' ? deAllocateNdcRosi : deAllocateNdcPqas;
    let totalAmount = deAllocateNdcRow?.filter(
      (x) => x?.id === activeRow?.id
    )[0]?.changeAmt;
    let headerLevelTotAllocateAmt = 0;
    const newObj = ROSIGridRowData?.filter((x) => {
      return (
        (x.invRecSeqNum === allocatePaymentHeaderDetail?.reconciliationNumber ||
          x.invRecSeqNum === 0) &&
        x.addEditRow
      );
    });
    if (newObj && newObj?.length > 0) {
      const ccInterestAllocatedAmt =
        singleDisabledIntPaidColObjRosi?.summaryGirdIntPaidColumnDisabled
          ? calculateTotalSum('ccInterestAllocated', newObj)
          : 0;
      const paidAmount = calculateTotalSum('paidAmt', newObj);
      const calulateTotalAmt = parseFloat(
        parseFloat(paidAmount || 0) +
          parseFloat(ccInterestAllocatedAmt || 0) +
          parseFloat(allocatePaymentHeaderDetail?.oldOriginalAllocateAmt || 0)
      );
      headerLevelTotAllocateAmt = parseFloat(
        parseFloat(calulateTotalAmt || 0) -
          parseFloat(calculateTotalSum('changeAmt', deAllocateNdcRow) || 0)
      );
      totalAmount = 0;
    } else {
      headerLevelTotAllocateAmt = parseFloat(
        allocateDetailObj?.totAllocatedAmt || 0
      );
    }

    const calAmt = parseFloat(
      parseFloat(headerLevelTotAllocateAmt || 0) - parseFloat(totalAmount || 0)
    ).toFixed(2);

    headerAllocatePaymentData[`${activeInvNum}-${activeCheckLogNum}`] = {
      ...allocatePaymentHeaderDetail,
      originalTotAllocatedAmt: calAmt,
      totAllocatedAmt: calAmt,
    };
    dispatch(
      dispatchAllocatePaymentHederData(
        headerAllocatePaymentData,
        activeInvNum,
        activeCheckLogNum
      )
    );
    setAllocateDetailObj({
      ...allocatePaymentHeaderDetail,
      originalTotAllocatedAmt: calAmt,
      totAllocatedAmt: calAmt,
    });
    return calAmt;
  };
  // click on yes button after call
  const masterDataSave = () => {
    saveAllocateDetail();
    setFlag1(false);
    setFlag2(false);
    setDeclareCheckUnallocatedMsg('');
    handleSaveClose();
  };
  // check DeallocatedRows before save
  const checkDeallocatedRows = () => {
    let pqasGridDataNew =
      pqasGridData !== undefined && pqasGridData.length > 0
        ? pqasGridData
            ?.filter((item) => item.addEditRow || item.addEditRowSummary)
            ?.map((item) => {
              return {
                ...item,
                invStatusCd: getPreInitData?.invoiceStatusCd,
                checkReceivedDt: allocatePaymentHeaderDetail?.receivedDt
                  ? moment(allocatePaymentHeaderDetail?.receivedDt).format(
                      'MM/DD/YYYY'
                    )
                  : null,
              };
            })
        : [];
    let deallocAteRowNumbers = [];
    pqasGridDataNew.forEach(function (item) {
      if (
        item.isModifiedCurrUnitsDisputedColumn &&
        item.currUnitsDisputedRowNumber &&
        parseFloat(item.currUnitsPaid) === 0 &&
        parseFloat(item.currAmtPaid) === 0 &&
        parseFloat(item.paidThisTransactionAmt) === 0
      ) {
        deallocAteRowNumbers.push(item.currUnitsDisputedRowNumber);
      }
    });
    let stringRowNums = deallocAteRowNumbers.toString();
    if (deallocAteRowNumbers.length != 0) {
      setStringDeallocateRowNums(stringRowNums);
    } else {
      setStringDeallocateRowNums('');
    }
  };
  // click on Cancel button Save data and close Tab
  const masterDataSaveAndClose = async (val, navigationData) => {
    dispatch(dispatchROSIGridList([]));
    setDeclareCheckUnallocatedMsg('');
    dispatch(dispatchColIdForPqas(''));
    const newObj = activeInvoiceNumArray || [];
    const { values } = searchPickInvAssociateScreenObj;
    const prevData =
      pervSearchPickInvScreenData[values?.invoiceNumber]?.selectedRow;
    const resultData = await dispatch(
      getRosiAllocatePaymentDetail({
        invoiceNum:
          navigationData?.invoiceNum || allocatePaymentHeaderDetail?.invoiceNum,
        checkLogNum:
          navigationData?.checkLogNum ||
          allocatePaymentHeaderDetail?.checkLogNum ||
          activeCheckLogNum,
        checkPayeeCD:
          fetchSearchScreenData?.state?.allocateFrom === 'Check'
            ? fetchSearchScreenData?.selectedRow?.checkPayeeCdVal ||
              fetchSearchScreenData?.selectedRow?.checkPayeeCd
            : 'ALL',
        checkAmt: allocatePaymentHeaderDetail?.checkAmt
          ? parseFloat(
              allocatePaymentHeaderDetail.checkAmt?.toString().split('$')[1]
            )
          : 0,
        mfgId: values?.selectedBy === 'IN' ? '' : prevData?.mfgId || '',
        planType: values?.selectedBy === 'IN' ? '' : values?.planTypeCd || '',
      })
    );

    const data = resultData?.headerAllocatePaymentData;
    const headerAllocatePaymentVO =
      resultData?.headerAllocatePaymentData?.headerAllocatePaymentVO;
    if (
      headerAllocatePaymentVO &&
      Object?.keys(headerAllocatePaymentVO)?.length > 0 &&
      !closedRef?.current
    ) {
      let currPreNxtQtr = pqasGridLevelActions?.pgQtrVal;
      // if (
      //   saveDetailApiResponse?.data?.apiResponse === 'Save Bypass Update' ||
      //   saveDetailApiResponse?.data?.apiResponse === 'Successfully Saved'
      // ) {
      //   currPreNxtQtr = pqasGridLevelActions?.pgQtrVal;
      // }
      getAllocatePaymentScreenData(
        data,
        dispatch,
        AllocatePaymentReducer,
        history,
        newObj,
        pqasGridLevelActions,
        currPreNxtQtr
      );
      handleSaveClose();
    }
    const temp = { ...addEditAllocatePaymentDetailAllScreenObj };
    temp[`${activeInvNum}-${activeCheckLogNum}`] = {
      ...temp[`${activeInvNum}-${activeCheckLogNum}`],
      ...(val !== undefined && val !== null ? { tabValue: val } : {}),
      rowIndex: 0,
      defaultRow: true,
    };
    dispatch(addReduxDataUpdateAllocatePaymentDetailTab(temp));
    const tempObj = { ...updateDetailsAllData };
    tempObj[`${activeInvNum}-${activeCheckLogNum}`] = {
      ...tempObj[`${activeInvNum}-${activeCheckLogNum}`],
      flag: true,
    };
    dispatch(setUpdateDetails(tempObj));
    const storeData1 = {
      ...deAllocateNdcPqas,
      [`${activeInvNum}-${activeCheckLogNum}`]: [],
    };
    dispatch(deallocateNdcPqasStore(storeData1));
    const tempNewData = {
      ...addOrDuplicateNDCAll,
      [`${activeInvNum}-${activeCheckLogNum}`]: [],
    };
    dispatch(addOrDuplicateNDCPQASObjData(tempNewData));
    dispatch(isHandleOkPayRem(''));
    dispatch(isHandleOkPayRem(false));
  };

  // click on cancel after call
  const handleSaveClose = () => {
    //dispatch(isHandleOkPayRem(''));
    setOpen(false);
    setOpenCancel(false);
    //dispatch(isHandleOkPayRem(false));
  };

  const preInitialization = () => {
    const il_rpsn =
      allocatePaymentHeaderDetail?.recancilationNumber === null
        ? 0
        : allocatePaymentHeaderDetail?.recancilationNumber;
    setPreValues({
      ib_retrieved: true,
      ib_opening: true,
      idec_invoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
      il_checkNum: allocatePaymentHeaderDetail?.checkLogNum,
      idbl_ub: allocatePaymentHeaderDetail?.idblmfgUB,
      il_rpsn,
    });
  };

  // When change qtr pagination in PQAS tab then this function called
  React.useEffect(() => {
    if (!_.isEmpty(pqasGridLevelActions)) {
      if (
        pqasGridLevelActions?.prevNextRecord &&
        !_.eq(preValues.prevQtr, pqasGridLevelActions?.pgQtrVal)
      ) {
        dispatch(dispatchGetInvoiceHeader([]));
        const newData = {
          ...preValues,
          prevQtr: pqasGridLevelActions?.pgQtrVal,
        };
        const pqasAction = {
          ...pqasGridLevelAllActions,
          [`${activeInvNum}-${activeCheckLogNum}`]: {
            ...pqasGridLevelActions,
            prevNextRecord: false,
          },
        };
        dispatch(dispatchPQASGridLevelActions({ ...pqasAction }));
        onLoadPqasGrid(
          pqasGridData,
          allocatePaymentHeaderDetail,
          pqasGridLevelActions,
          dispatch
        );
        setPreValues(newData);
      }
    }
  }, [pqasGridLevelActions?.pgQtrVal]);
  // Declare Check Allocated (allocate payment part3)
  const checkInterestExists = () => {
    setCheckAllocatedView(false);
    setInterestPaymentExistsView(false);
  };

  const cancelPaymentExitView = () => {
    if (flag) {
      pqasFunc();
    } else if (
      !flag &&
      parseFloat(allocateDetailObj.checkAmt) !==
        parseFloat(allocateDetailObj.totAllocatedAmt)
    ) {
      setInterestPaymentExistsView(false);
      setCheckAllocated(true);
    } else if (
      !flag &&
      parseFloat(allocateDetailObj.checkAmt) ===
        parseFloat(allocateDetailObj.totAllocatedAmt)
    ) {
      CheckAllocatedClick();
    }
  };

  const cancelCheckAllocated = () => {
    setCheckAllocated(false);
    setInterestPaymentExistsView(false);
  };
  const CheckAllocatedClick = (params, skipSuspendedDate = false) => {
    const suspendedDate =
      params === 'declareCheckAllocated' && !skipSuspendedDate
        ? moment().format('MM/DD/YYYY')
        : null;
    dispatch(
      getDeclareCheckAllocation({
        checkLogNum: parseFloat(allocatePaymentHeaderDetail?.checkLogNum),
        checkAmt: allocateDetailObj.checkAmt,
        totAllocatedCheckAmt: parseFloat(allocateDetailObj.totAllocatedAmt),
        flag: 'Yes',
        suspendedDate,
      })
    );
    setCheckAllocated(false);
    setInterestPaymentExistsView(false);
    setAllocateFlag(true);
    const tempObj = headerAllocatePaymentData;

    tempObj[`${activeInvNum}-${activeCheckLogNum}`].allocationCompleteInd = 1;
    setAllocateDetailObj({
      ...allocateDetailObj,
      allocationCompleteInd: 1,
    });

    dispatch(
      dispatchAllocatePaymentHederData(tempObj, activeInvNum, activeCheckLogNum)
    );
    saveAllocateDetail(params, undefined, suspendedDate);
    if (!skipSuspendedDate) {
      handleClearReduxData(activeInvNum, activeCheckLogNum, 'closeTab');
    }
  };
  const pqasFunc = () => {
    if (pqasGridData !== undefined && pqasGridData.length > 0) {
      if (parseFloat(pqasSummaryGridList[0]?.intPaidThisCheck) > 0) {
        const arr = pqasGridData?.filter((item) => {
          if (item?.interestSettledInd?.toString() === '0') {
            return item;
          }
        });

        if (arr?.length > 0) {
          setFlag(false);
          setInterestPaymentExistsView(true);
        } else if (
          arr?.length === 0 &&
          parseFloat(allocateDetailObj.checkAmt) ===
            parseFloat(allocateDetailObj.totAllocatedAmt)
        ) {
          CheckAllocatedClick();
        } else if (
          arr?.length === 0 &&
          parseFloat(allocateDetailObj.checkAmt) !==
            parseFloat(allocateDetailObj.totAllocatedAmt)
        ) {
          setCheckAllocated(true);
        }
      } else if (
        parseFloat(pqasSummaryGridList[0].intPaidThisCheck) == 0 &&
        parseFloat(allocateDetailObj.checkAmt) ===
          parseFloat(allocateDetailObj.totAllocatedAmt)
      ) {
        CheckAllocatedClick();
      } else if (
        parseFloat(pqasSummaryGridList[0].intPaidThisCheck) == 0 &&
        parseFloat(allocateDetailObj.checkAmt) !==
          parseFloat(allocateDetailObj.totAllocatedAmt)
      ) {
        setCheckAllocated(true);
      }
    } else if (
      parseFloat(allocateDetailObj.checkAmt) ===
      parseFloat(allocateDetailObj.totAllocatedAmt)
    ) {
      CheckAllocatedClick();
    } else {
      setCheckAllocated(true);
    }
  };

  // ROSI funct
  const rosiFunc = () => {
    if (ROSIGridRowData !== undefined && ROSIGridRowData.length > 0) {
      if (parseFloat(summaryGridReduxData[0].intPaid) > 0) {
        const arr = ROSIGirdAllRowData[
          `${activeInvNum}-${activeCheckLogNum}`
        ]?.filter((item) => {
          if (item?.interestSettledInd?.toString() === '0') {
            return item;
          }
        });
        if (arr.length > 0) {
          setFlag(true);
          setInterestPaymentExistsView(true);
        } else {
          pqasFunc();
        }
      } else {
        pqasFunc();
      }
    } else {
      pqasFunc();
    }
  };
  const handleUnallocatedBalanceAfterOk = () => {
    dispatch(
      getUnallocatedBalanceAmt({
        checkLogNumber: allocatePaymentHeaderDetail?.checkLogNum,
        rebateProgramCd: allocatePaymentHeaderDetail?.rebateProgramCd,
        mfgId: allocatePaymentHeaderDetail?.mfgId,
        mfgUB: allocatePaymentHeaderDetail?.checkAmt,
        checkAmt: allocatePaymentHeaderDetail?.idblmfgUB,
        recordStatus: 'Y',
        lastUserId: logInUserID,
      })
    );
    const newObj = allocatePaymentHeaderDetail;
    newObj.checkAmt = parseFloat(
      parseFloat(newObj.checkAmt || 0) +
        parseFloat(allocatePaymentHeaderDetail?.idblmfgUB || 0)
    );
    newObj.totAllocatedAmt = allocateDetailObj.totAllocatedAmt;
    headerAllocatePaymentData[`${activeInvNum}-${activeCheckLogNum}`] = newObj;
    setAllocateDetailObj({
      ...newObj,
      totAllocatedAmt: allocateDetailObj.totAllocatedAmt,
    });
    dispatch(
      dispatchAllocatePaymentHederData(
        headerAllocatePaymentData,
        activeInvNum,
        activeCheckLogNum
      )
    );
  };
  const checkIntGrid = () => {
    setCheckAllocatedView(false);
    setFlag(false);
    rosiFunc();
  };

  const declareCheckAllocated = () => {
    if (
      parseFloat(allocateDetailObj?.checkAmt) !== 0 &&
      parseFloat(allocateDetailObj.totAllocatedAmt) === 0
    ) {
      setCheckAllocatedView(true);
    } else {
      rosiFunc();
    }
  };

  // NO pay Suspended (allocate payment part3)

  const noPaySuspendClick = async () => {
    if (parseFloat(allocateDetailObj.totAllocatedAmt) > 0) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      if (updateTabs.length > 0) {
        updateTabs.map((item) => {
          setModalTitle('ROSI/PQAS');
        });
      }
      setWarningAlert(true);
      setWaringMessage(constantMessageData.ALREADY_EXIST_PAYMENT_FOR_CHECK);
    } else {
      await dispatch(
        noPaySuspended({
          invoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
          checkLogNumber: allocatePaymentHeaderDetail?.checkLogNum,
          totAllocatedAmt: allocatePaymentHeaderDetail?.totAllocatedAmt,
          lastUpdatedId: logInUserID,
          status: false,
        })
      );
    }
  };

  // click on full screen icon after call in Check grid
  const handleFullScreenViewForFirstGrid = () => {
    if (!fullScreenViewForFirstGrid) {
      handleScrollToEvent();
    }
    setFullScreenViewForFirstGrid(!fullScreenViewForFirstGrid);
    const temp = { ...addEditAllocatePaymentDetailAllScreenObj };
    temp[`${activeInvNum}-${activeCheckLogNum}`] = {
      ...temp[`${activeInvNum}-${activeCheckLogNum}`],
      fullScreenViewForFirstGrid: !fullScreenViewForFirstGrid,
      fullScreenViewForSecondGrid: false,
    };
    dispatch(addReduxDataUpdateAllocatePaymentDetailTab(temp));
  };
  // click on full screen icon after call in Check grid
  const handleFullScreenViewForSecondGrid = () => {
    if (!fullScreenViewForSecondGrid) {
      handleScrollToEvent();
    }
    setFullScreenViewForSecondGrid(!fullScreenViewForSecondGrid);
    const temp = { ...addEditAllocatePaymentDetailAllScreenObj };
    temp[`${activeInvNum}-${activeCheckLogNum}`] = {
      ...temp[`${activeInvNum}-${activeCheckLogNum}`],
      fullScreenViewForSecondGrid: !fullScreenViewForSecondGrid,
      fullScreenViewForFirstGrid: false,
    };
    dispatch(addReduxDataUpdateAllocatePaymentDetailTab(temp));
  };
  // handing Invoice Detail page redirect
  const goToInvoiceDetail = async () => {
    await dispatch(
      getInvoiceDetailsByInvoiceNum({
        invoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
      })
    );
    redirectURLLink('/display-invoice', 'Display Invoice', history, dispatch);
  };
  // handing go To maintain check page redirect
  const goToMaintainCheck = async () => {
    dispatch(maintainCheckReqAction({}));
    dispatch(maintainCheckErrorMessageAction([]));
    dispatch(maintainCheckFormErrorAction({}));
    const newData = {
      checkLogNum: allocatePaymentHeaderDetail?.checkLogNum,
      batchNum: null,
      checkNum: null,
      disputeResolutionCd: null,
      notDrugRebateInd: null,
      checkIdentifier: null,
      checkPayeeCd: null,
      lastUpdateUserId: null,
      checkIssuer: null,
      checkInfo: null,
      paymentMediaTypeCd: null,
      invRecFormatCd: null,
      checkDt: null,
      toCheckDt: null,
      suspendedDt: null,
      toSuspendedDt: null,
      postmarkedDt: null,
      toPostmarkedDt: null,
      batchDt: null,
      toBatchDt: null,
      receivedDt: null,
      toReceivedDt: null,
    };
    window.localStorage.setItem('initialSearchValues', JSON.stringify(newData));
    const response = await dispatch(getSearchCheckResults(newData));
    if (response && response?.checkSearchValues?.length > 0) {
      window.localStorage.setItem(
        'checkSearchValues',
        JSON.stringify(response?.checkSearchValues[0])
      );
      redirectURLLink('/maintain-check', 'Maintain Check', history, dispatch);
    }
  };
  // handle OncloseTab
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return (
          x.navTo ===
            `/allocatePaymentDetail/${allocatePaymentHeaderDetail?.checkLogNum}-${allocatePaymentHeaderDetail?.invoiceNum}` &&
          x.isFormSave
        );
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (
          item.navTo ===
            `/allocatePaymentDetail/${allocatePaymentHeaderDetail?.checkLogNum}-${allocatePaymentHeaderDetail?.invoiceNum}` &&
          item.isFormSave
        ) {
          item.isFormSave = false;
          setHandleTabValue(true);
          setFlag1(true);
          saveAllocateDetail();
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);
  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (
          item.navTo ===
            `/allocatePaymentDetail/${allocatePaymentHeaderDetail?.checkLogNum}-${allocatePaymentHeaderDetail?.invoiceNum}` &&
          !disabledSaveCancelBtn
        ) {
          item.isFormDirty = true;
        } else if (
          item.navTo ===
            `/allocatePaymentDetail/${allocatePaymentHeaderDetail?.checkLogNum}-${allocatePaymentHeaderDetail?.invoiceNum}` &&
          errorMessagesFromRedux?.detailScreenErrors?.[
            `${activeInvNum}-${activeCheckLogNum}`
          ] &&
          errorMessagesFromRedux?.detailScreenErrors?.[
            `${activeInvNum}-${activeCheckLogNum}`
          ][0]?.errorType === 'errorMessage'
        ) {
          item.isFormDirty = true;
        } else if (
          item.navTo ===
          `/allocatePaymentDetail/${allocatePaymentHeaderDetail?.checkLogNum}-${allocatePaymentHeaderDetail?.invoiceNum}`
        )
          item.isFormDirty = false;
        return item;
      });

    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [disabledSaveCancelBtn]);
  // handle close tab after come error
  const handleCloseTab = (params = '') => {
    setCheckNotAssociatedWithInvoice(false);
    handleClearReduxData(activeInvNum, activeCheckLogNum, params);
    // setTimeout(() => {
    //   closeTab(
    //     `/allocatePaymentDetail/${allocatePaymentHeaderDetail?.checkLogNum}-${allocatePaymentHeaderDetail?.invoiceNum}`,
    //     history,
    //     ''
    //     // {
    //     //   navTo: '/allocatePayment',
    //     //   value: 'Allocate Payments',
    //     // }
    //   );
    // }, 4000);
  };
  const handleMouseDown = () => {
    if (!saveAgainAlert && isColumnDone) {
      setWarningAlert(true);
      setSaveAgainAlert(true);
      setModalTitle(ROSI_PQAS_ALERT_TITLE);
      setWaringMessage(SAVE_AGAIN_ALERT_MESSAGE);
      setOpen(false);
      setSameAmountForCheck(false);
      dispatch(dispatchIsColumnDone(false));
    } else {
      dispatch(dispatchIsColumnDone(false));
    }
  };
  return (
    <div
      className="tBillPanel custom-check tabs-container"
      data-testid="CheckLetter-component"
    >
      <CustomSeparator
        parent1="Tasks"
        parent2={`ROSI / PQAS[${allocatePaymentHeaderDetail?.mfgId} Inv #:${allocatePaymentHeaderDetail?.invoiceNum} Chk Log #: ${allocatePaymentHeaderDetail?.checkLogNum}]`}
      />
      <SaveCancelPopup
        open={saveView}
        title="ROSI/PQAS"
        data-testid="save-api-uc"
        content="Leave now and suspend check?"
        onConfim={majorSave}
        onCancel={() => setSaveView(false)}
        moduleName=""
      />
      <SaveCancelPopup
        open={checkAllocated}
        title="ROSI/PQAS"
        content="Total Allocated Amount does not equal the Check Amount. If you leave now the check will be suspended. Leave now and suspend the check?"
        data-testid="check-allocated-api-uc"
        onConfim={() => {
          CheckAllocatedClick('declareCheckAllocated');
        }}
        onCancel={() => cancelCheckAllocated()}
        moduleName=""
      />
      <SaveCancelPopup
        open={checkAllocatedView}
        title="ROSI/PQAS"
        content="No ROSI/PQAS payments have been made, are you sure you want to mark this check allocated?"
        data-testid="check-allocated-api-uc"
        onConfim={checkIntGrid}
        onCancel={() => setCheckAllocatedView(false)}
        moduleName=""
      />
      <SaveCancelPopup
        open={interestPaymentExistsView}
        title="ROSI/PQAS"
        data-testid="interest-exists-api-uc"
        content="Interest payments exist on ROSI but no interest settled designations have been made.  Would you like to cancel this action and return to ROSI/PQAS to make those designations?"
        onConfim={checkInterestExists}
        onCancel={() => cancelPaymentExitView()}
        moduleName=""
      />
      {!fullScreenViewForFirstGrid && (
        <>
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesFromRedux?.detailScreenErrors?.[
                  `${activeInvNum}-${activeCheckLogNum}`
                ]?.length > 0
                  ? _.filter(
                      errorMessagesFromRedux?.detailScreenErrors?.[
                        `${activeInvNum}-${activeCheckLogNum}`
                      ],
                      (l) => l.field === 'failedMessage' && l.message
                    ).map((val) => val.message)
                  : []
              ),
            ]}
          />
          <DisplaySuccessMessages
            successMessages={[
              ...new Set(
                errorMessagesFromRedux?.detailScreenErrors?.[
                  `${activeInvNum}-${activeCheckLogNum}`
                ]?.length > 0
                  ? _.filter(
                      errorMessagesFromRedux?.detailScreenErrors?.[
                        `${activeInvNum}-${activeCheckLogNum}`
                      ],
                      (l) => l.field === 'SucessMessage' && l.message
                    ).map((val) => val.message)
                  : []
              ),
            ]}
          />
          {discrepancyAlert && (
            <DiscrepancyWarningMsg
              handleClose={() => {
                setDiscrepancyAlert(false);
                setDiscrepancyMsg([]);
              }}
              discrepancyMsg={
                discrepancyMsg?.length > 0
                  ? [
                      ...new Map(
                        discrepancyMsg?.map((item) => {
                          return [item.title, item];
                        })
                      )?.values(),
                    ]
                  : []
              }
            />
          )}
        </>
      )}
      {!fullScreenViewForFirstGrid && !fullScreenViewForSecondGrid && (
        <div>
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id="action-tooltip">Action</Tooltip>}
          >
            <Dropdown className="icon-dropdown-container frr-lab-diff-action-icon-container">
              <Dropdown.Toggle
                className="icon-dropdown"
                aria-label="Show Contracts using this Contact"
              >
                <SVGComponent iconName="Icon-export" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  role="button"
                  data-testid="declareCheckAllocated"
                  onClick={() => {
                    if (hasInvalidValueError(errorMessagesFromRedux)) {
                      window.scrollTo(0, 0);
                      return;
                    }
                    if (
                      parseFloat(allocateDetailObj?.totAllocatedAmt) ===
                        parseFloat(allocatePaymentHeaderDetail?.checkAmt) &&
                      allocatePaymentHeaderDetail?.allocationCompleteInd != 1
                    ) {
                      setDeclareCheckUnallocatedMsg('declareCheckAllocated');
                      setSameAmountForCheck(true);
                      setModalTitle(ROSI_PQAS_ALERT_TITLE);
                      setWaringMessage(
                        constantMessageData.ALLOCATE_AMT_CHECK_AMT_SAME_ERROR
                      );
                    } else {
                      declareCheckAllocated();
                    }
                  }}
                  disabled={isEnablebyRole}
                >
                  Declare Check Allocated
                </Dropdown.Item>
                <Dropdown.Item
                  role="button"
                  data-testid="noPaySuspend"
                  onClick={() => noPaySuspendClick()}
                  disabled={isEnablebyRole}
                >
                  No Pay Suspend
                </Dropdown.Item>
                <Dropdown.Item
                  role="button"
                  data-testid="goToMaintainCheck"
                  onClick={() => goToMaintainCheck()}
                  //disabled={isEnablebyRole}
                >
                  Go to Maintain Check
                </Dropdown.Item>
                <Dropdown.Item
                  role="button"
                  data-testid="goToInvoice"
                  onClick={() => goToInvoiceDetail()}
                  //disabled={isEnablebyRole}
                >
                  Go to Invoice
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </OverlayTrigger>
        </div>
      )}
      <Spinner load={spinnerLoader} />
      <div className="no-margin mt-5">
        {!fullScreenViewForFirstGrid && !fullScreenViewForSecondGrid && (
          <>
            <Box className="panel custom-fieldset frr-textfields">
              <div className="custom-check">
                <div className="form-wrapper form-wrapper-col-4">
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="invoiceNumber"
                      label="Invoice Number"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 38, id: 'invoiceNumber' }}
                      value={allocatePaymentHeaderDetail?.invoiceNum}
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="Manufacturer ID"
                      label="Manufacturer ID"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 10, id: 'Manufacturer ID' }}
                      value={allocatePaymentHeaderDetail?.mfgId}
                    />
                  </div>
                  <div
                    className={
                      isNaN(parseFloat(allocateDetailObj?.totAllocatedAmt))
                        ? 'mui-custom-form input-md'
                        : `mui-custom-form input-md ${
                            parseFloat(allocateDetailObj?.totAllocatedAmt) >
                            parseFloat(allocateDetailObj?.checkAmt)
                              ? 'frr-color-class-red-custom'
                              : ''
                          } ${
                            parseFloat(allocateDetailObj?.totAllocatedAmt) >= 0
                              ? ''
                              : 'frr-color-red'
                          }`
                    }
                  >
                    <TextField
                      id="allocatedAmount"
                      label="Allocated Amount"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      value={
                        isNaN(parseFloat(allocateDetailObj?.totAllocatedAmt))
                          ? '$ 0.00'
                          : `${
                              parseFloat(allocateDetailObj?.totAllocatedAmt) >=
                              0
                                ? `$ ${parseFloat(
                                    allocateDetailObj?.totAllocatedAmt
                                  ).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}`
                                : `($ ${parseFloat(
                                    allocateDetailObj.totAllocatedAmt
                                  )
                                    ?.toString()
                                    ?.replace('-', '')
                                    .trim()})`
                            }`
                      }
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="rebateProgramCd"
                      label="Rebate Program"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 10, id: 'rebateProgramCd' }}
                      value={allocatePaymentHeaderDetail?.rebateProgramCd}
                    />
                  </div>
                </div>
              </div>
              <div className="form-wrapper form-wrapper-col-4">
                <div className="mui-custom-form input-md">
                  <TextField
                    id="invoiceQ"
                    label="Invoice Quarter"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ maxLength: 6, id: 'invoiceQ' }}
                    value={
                      allocatePaymentHeaderDetail?.qtr &&
                      handleQuarterFormate(allocatePaymentHeaderDetail?.qtr)
                    }
                  />
                </div>
                <div className="mui-custom-form input-md">
                  {allocatePaymentHeaderDetail?.mfgName?.length > 20 ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="com-tooltip">
                          {allocatePaymentHeaderDetail?.mfgName}
                        </Tooltip>
                      }
                    >
                      <TextField
                        id="mfgName"
                        label="Manufacturer Name"
                        fullWidth
                        disabled
                        placeholder=""
                        InputLabelProps={{ shrink: true }}
                        value={`${allocatePaymentHeaderDetail?.mfgName.substring(
                          0,
                          20
                        )} ...`}
                      />
                    </OverlayTrigger>
                  ) : (
                    <TextField
                      id="mfgName"
                      label="Manufacturer Name"
                      fullWidth
                      disabled
                      placeholder=""
                      InputLabelProps={{ shrink: true }}
                      value={allocatePaymentHeaderDetail?.mfgName}
                    />
                  )}
                </div>
                <div
                  className={`mui-custom-form input-md ${
                    isNaN(parseFloat(allocateDetailObj?.checkAmt))
                      ? ''
                      : parseFloat(allocateDetailObj?.checkAmt) >= 0
                      ? ''
                      : 'frr-color-red'
                  }`}
                >
                  <TextField
                    id="batch-total-amount-of-check-detail"
                    label="Available to Allocate"
                    fullWidth
                    disabled
                    placeholder=""
                    InputLabelProps={{ shrink: true }}
                    value={
                      isNaN(parseFloat(allocateDetailObj?.checkAmt))
                        ? '$ 0.00'
                        : `${
                            parseFloat(allocateDetailObj?.checkAmt) >= 0
                              ? `$ ${parseFloat(
                                  allocateDetailObj?.checkAmt
                                ).toLocaleString('en-US', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}`
                              : `($ ${parseFloat(allocateDetailObj?.checkAmt)
                                  ?.toString()
                                  ?.replace('-', '')
                                  .trim()})`
                          }`
                    }
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <FormControlLabel
                    className="ml-0 mt-4"
                    data-testid="allocationCompleteInd"
                    control={<Checkbox color="primary" className="mr-2" />}
                    label="Allocation Complete"
                    checked={
                      allocatePaymentHeaderDetail?.allocationCompleteInd === 1
                    }
                    value={
                      allocatePaymentHeaderDetail?.allocationCompleteInd === 1
                    }
                    disabled
                  />
                </div>
              </div>
              <div className="form-wrapper form-wrapper-col-4">
                <div className="mui-custom-form input-md">
                  <div className="comment-sec ">
                    Comments &nbsp;
                    <img
                      role="button"
                      onClick={() => {
                        setShowComments(true);
                      }}
                      tabIndex="0"
                      onKeyDown={(e) => {
                        // Handle Enter and Space key events
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault(); // Prevents the default space scrolling behavior
                          setShowComments(true);
                        }
                      }}
                      alt="comment"
                      src={
                        parseInt(
                          allocatePaymentHeaderDetail?.ccCommentsExist,
                          [0, 1]
                        ) === 1
                          ? CommentVisibleIcon
                          : CommentIcon
                      }
                    />
                  </div>
                </div>
              </div>
            </Box>
            <div className="flex-block justify-end pb-1 mt-3">
              <div className="btn-wrapper float-right">
                <Button
                  className="btn btn-success btn-save"
                  data-testid="saveBtn1"
                  id="saveBtn1"
                  disabled={disabledSaveCancelBtn || isEnablebyRole}
                  onClick={() => {
                    if (hasInvalidValueError(errorMessagesFromRedux)) {
                      window.scrollTo(0, 0);
                      return;
                    }
                    if (isColumnDone) {
                      setWarningAlert(true);
                      setSaveAgainAlert(true);
                      setModalTitle(ROSI_PQAS_ALERT_TITLE);
                      setWaringMessage(SAVE_AGAIN_ALERT_MESSAGE);
                      setOpen(false);
                      dispatch(dispatchIsColumnDone(false));
                    } else {
                      if (
                        parseFloat(allocateDetailObj?.totAllocatedAmt) ===
                          parseFloat(allocatePaymentHeaderDetail?.checkAmt) &&
                        allocatePaymentHeaderDetail?.allocationCompleteInd != 1
                      ) {
                        setOpen(false);
                        setSaveAgainAlert(true);
                        setDeclareCheckUnallocatedMsg('majorSave');
                        setSameAmountForCheck(true);
                        setModalTitle(ROSI_PQAS_ALERT_TITLE);
                        setWaringMessage(
                          constantMessageData.ALLOCATE_AMT_CHECK_AMT_SAME_ERROR
                        );
                      } else {
                        setOpen(true);
                        setSaveAgainAlert(true);
                        checkDeallocatedRows();
                      }
                    }
                  }}
                  onMouseDown={handleMouseDown}
                >
                  {' '}
                  <SVGComponent iconName="Icon-awesome-save" />
                  Save
                </Button>
                <Button
                  className="btn btn-cancel"
                  data-testid="cancelBtn1"
                  disabled={disabledSaveCancelBtn || isEnablebyRole}
                  onClick={setOpenCancel}
                >
                  <SVGComponent iconName="Icon-cancel" />
                  Cancel
                </Button>
              </div>
            </div>
          </>
        )}
        <div>
          <AllocatePaymentTab
            handleChangeTabValue={(event, newValue) => {
              if (hasInvalidValueError(errorMessagesFromRedux)) {
                window.scrollTo(0, 0);
                return;
              }
              if (!disabledSaveCancelBtn) {
                setOpenTabClose(true);
              } else {
                setTabValue(newValue);
                const temp = { ...addEditAllocatePaymentDetailAllScreenObj };
                temp[`${activeInvNum}-${activeCheckLogNum}`] = {
                  ...temp[`${activeInvNum}-${activeCheckLogNum}`],
                  tabValue: newValue,
                };
                dispatch(addReduxDataUpdateAllocatePaymentDetailTab(temp));
              }
            }}
            tabValue={tabValue}
          />
        </div>
        <div className="tabs-body">
          {tabValue === 'one' && (
            <Suspense fallback={<div>Loading...</div>}>
              <AllocatePaymentROSIGridComponent
                fullScreenViewForFirstGrid={fullScreenViewForFirstGrid}
                saveAllocateDetail={saveAllocateDetail}
                calculateAllocateAmount={calculateAllocateAmount}
                handleFullScreenViewForFirstGrid={
                  handleFullScreenViewForFirstGrid
                }
                fullScreenViewForSecondGrid={fullScreenViewForSecondGrid}
                handleFullScreenViewForSecondGrid={
                  handleFullScreenViewForSecondGrid
                }
                allocatePaymentHeaderDetail={allocatePaymentHeaderDetail}
                headerAllocatePaymentData={headerAllocatePaymentData}
                activeInvNum={activeInvNum}
                activeCheckLogNum={activeCheckLogNum}
                commonDropdownList={commonDropdownList}
                setAllocateDetailObj={setAllocateDetailObj}
                setDiscrepancyAlert={setDiscrepancyAlert}
                setDiscrepancyMsg={setDiscrepancyMsg}
                setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
                handleFieldError={handleFieldError}
                fieldsValidity={fieldsValidity}
                isEnablebyRole={isEnablebyRole}
              />
            </Suspense>
          )}
          {tabValue === 'two' && (
            <Suspense fallback={<div>Loading...</div>}>
              <AllocatePaymentPQASGridComponent
                preValues={preValues}
                fullScreenViewForFirstGrid={fullScreenViewForFirstGrid}
                handleFullScreenViewForFirstGrid={
                  handleFullScreenViewForFirstGrid
                }
                fullScreenViewForSecondGrid={fullScreenViewForSecondGrid}
                handleFullScreenViewForSecondGrid={
                  handleFullScreenViewForSecondGrid
                }
                allocatePaymentHeaderDetail={allocatePaymentHeaderDetail}
                activeInvNum={activeInvNum}
                activeCheckLogNum={activeCheckLogNum}
                commonDropdownList={commonDropdownList}
                setAllocateDetailObj={setAllocateDetailObj}
                saveAllocateDetail={saveAllocateDetail}
                declareCheckAllocated={declareCheckAllocated}
                setDiscrepancyAlert={setDiscrepancyAlert}
                setDiscrepancyMsg={setDiscrepancyMsg}
                calculateAllocateAmount={calculateAllocateAmount}
                setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
                handleFieldError={handleFieldError}
                fieldsValidity={fieldsValidity}
                hasInvalidValueError={hasInvalidValueError}
                isEnablebyRole={isEnablebyRole}
              />
            </Suspense>
          )}
        </div>
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="INVOICE_HEADER"
          corrLinkId={allocatePaymentHeaderDetail?.corrLinkId}
          rowGridPrimaryKey={allocatePaymentHeaderDetail?.checkLogNum}
        />
      ) : null}
      <CommonModal
        className="dialog-420"
        data-testid="common-modal-warning"
        open={warningAlert}
        viewAction
        viewHeader
        onOk={() => {
          setWarningAlert(false);
          if (checkNotAssociatedWithInvoice) {
            handleCloseTab();
          }
        }}
        onClose={() => {
          setWarningAlert(false);
          if (checkNotAssociatedWithInvoice) {
            handleCloseTab();
          }
        }}
        okTitle="Ok"
        modalTitle={modalTitle}
        childrenComponent={<div className="p-3">{warningMessage}</div>}
      />
      <CommonModal
        className="dialog-420"
        data-testid="common-modal-warning"
        open={sameAmountForCheck}
        viewAction
        viewHeader
        onOk={() => {
          setSameAmountForCheck(false);
          CheckAllocatedClick('declareCheckAllocated', true);
          handleCloseTab('closeTab');
        }}
        onClose={() => {
          setSameAmountForCheck(false);
          dispatch(setPopupCancelFlag());
          if (declareCheckUnallocatedMsg === 'majorSave') {
            setOpen(true);
            setSaveAgainAlert(true);
          }
        }}
        onCancel={() => {
          setSameAmountForCheck(false);
        }}
        okTitle="Ok"
        closeTitle="Cancel"
        modalTitle={modalTitle}
        childrenComponent={<div className="p-3">{warningMessage}</div>}
      />
      <CommonModal
        className="dialog-420"
        data-testid="common-modal-warning"
        open={unallocatedBalanceAlert}
        viewAction
        viewHeader
        onOk={() => {
          setUnallocatedBalanceAlert(false);
          handleUnallocatedBalanceAfterOk();
          dispatch(dispatchIsIDBLMfgUB(false));
        }}
        onClose={() => {
          setUnallocatedBalanceAlert(false);
          dispatch(dispatchIsIDBLMfgUB(false));
        }}
        okTitle="Yes"
        closeTitle="No"
        modalTitle={modalTitle}
        childrenComponent={<div className="p-3">{unallocatedBalErrorMsg}</div>}
      />
      <CommonModal
        className="dialog-420"
        data-testid="common-modal-warning"
        // open={!hasAcknowledged && summaryGridPopup}
        open={summaryGridPopup}
        viewAction
        viewHeader
        onOk={() => {
          setSummaryGridPopup(false);
          if (tabValue === 'two') {
            setTabValue('one');
          }
          dispatch(isHandleOkPayRem(true));
          //handleOkPayRem();
        }}
        onClose={() => {
          setSummaryGridPopup(false);
          dispatch(resetPopupAcknowledged());
        }}
        okTitle="Yes"
        closeTitle="No"
        modalTitle="ROSI/PQAS"
        childrenComponent={<div className="p-3">{summaryGridMsg}</div>}
      />
      <SaveCancelPopup
        open={saveDeallocateMsg}
        title={`ROSI/PQAS [${allocatePaymentHeaderDetail?.mfgId} Inv #:${allocatePaymentHeaderDetail?.invoiceNum} Chk Log #: ${allocatePaymentHeaderDetail?.checkLogNum}]`}
        data-testid="save-api-deallocate"
        content={`Row ${stringDeallocateRowNums} will be deallocated as Current Units Paid, Current amt Paid & amt Paid This Transaction are all 0. Do you want to continue?`}
        onConfim={() => {
          setSaveDeallocateMsg(false);
          masterDataSave();
          const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
          if (
            updateTabs?.filter((x) => {
              return x.redirectURLObj?.perviousNavTo;
            })?.length > 0
          ) {
            setReOpenNewTab(true);
          }
        }}
        onCancel={() => setSaveDeallocateMsg(false)}
      />
      <SaveCancelPopup
        open={open}
        data-testid="savePopup"
        title="Save"
        onConfim={() => {
          if (stringDeallocateRowNums != '') {
            setSaveDeallocateMsg(true);
            handleSaveClose();
          } else {
            masterDataSave();
            const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
            if (
              updateTabs?.filter((x) => {
                return x.redirectURLObj?.perviousNavTo;
              })?.length > 0
            ) {
              setReOpenNewTab(true);
            }
            setSaveDeallocateMsg(false);
          }
        }}
        onCancel={() => {
          handleSaveClose();
          setReOpenNewTab(false);
          const tabsRaw = localStorage.getItem('tabItemsData');
          if (!tabsRaw) return;
          let tabs;
          try {
            tabs = JSON.parse(tabsRaw);
          } catch {
            return;
          }
          const navigationObj = tabs.find(
            (t) => t?.redirectURLObj?.perviousNavTo
          );
          if (!navigationObj) return;

          const sourceInv = activeInvNum;
          const sourceCheck = activeCheckLogNum;

          const destInv = navigationObj.redirectURLObj?.invoiceNum;
          const destCheck = navigationObj.redirectURLObj?.checkLogNum;
          if (!destInv || !destCheck) return;

          const nextRoute =
            navigationObj.nextRoute ||
            `/allocatePaymentDetail/${destCheck}-${destInv}`;
          const nextTitle =
            navigationObj.nextTabTitle ||
            `ROSI/PQAS [Inv #:${destInv} Chk Log #: ${destCheck}]`;
          const cleanedTabs = tabs.map((t) => {
            if (t === navigationObj) {
              if (t.redirectURLObj) {
                delete t.redirectURLObj.perviousNavTo;
              }
              delete t.isSave;
              delete t.showConfirmClose;
              delete t.isClosing;
              t.closeTab = true;
            }
            return t;
          });
          localStorage.setItem('tabItemsData', JSON.stringify(cleanedTabs));
          closeTab(
            `/allocatePaymentDetail/${sourceCheck}-${sourceInv}`,
            history
          );
          redirectURLLink(nextRoute, nextTitle, history, dispatch);
        }}
      />
      <SaveCancelPopup
        open={openTabClose}
        data-testid="saveTabPopup"
        title="Save & Continue"
        onConfim={() => {
          setOpenTabClose(false);
          masterDataSave();
          let changeTabValue = 'one';
          if (tabValue === 'one') {
            changeTabValue = 'two';
          }
          setTabValue(changeTabValue);
          const temp = { ...addEditAllocatePaymentDetailAllScreenObj };
          temp[`${activeInvNum}-${activeCheckLogNum}`] = {
            ...temp[`${activeInvNum}-${activeCheckLogNum}`],
            tabValue: changeTabValue,
          };
          dispatch(addReduxDataUpdateAllocatePaymentDetailTab(temp));
        }}
        onCancel={() => {
          setOpenTabClose(false);
        }}
      />
      <SaveCancelPopup
        open={openCancel}
        data-testid="closePopup"
        title="Cancel"
        onConfim={() => {
          dispatch(
            handleErrorMessageForAllocatePayment({
              detailScreenErrors: [],
              searchScreenErrors: errorMessagesFromRedux?.searchScreenErrors
                ? errorMessagesFromRedux?.searchScreenErrors
                : [],
            })
          );
          masterDataSaveAndClose();
          if (!singleDisabledIntPaidColObjPqas?.isSave) {
            const newObjPQAS = disabledIntPaidAllPQAS;
            newObjPQAS[`${activeInvNum}-${activeCheckLogNum}`] = {
              ...singleDisabledIntPaidColObjPqas,
              pqasGridIntPaidColumnDisabled: false,
              summaryGirdIntPaidColumnDisabled: false,
              isSave: false,
            };
            dispatch(setDisabledValIntPaidPQAS(newObjPQAS));
          }
          if (!singleDisabledIntPaidColObjRosi?.isSave) {
            const disabledIntPaidObj = { ...disabledIntPaidAllROSI };
            disabledIntPaidObj[`${activeInvNum}-${activeCheckLogNum}`] = {
              ...singleDisabledIntPaidColObjRosi,
              rosiGridIntPaidColumnDisabled: false,
              summaryGirdIntPaidColumnDisabled: false,
              isSave: false,
            };
            dispatch(setDisabledValIntPaid(disabledIntPaidObj));
          }
          setDiscrepancyAlert(false);
          dispatch(setIsCanceling(false));
          dispatch(dispatchDiscrepancyNDCs([]));
        }}
        onCancel={() => {
          handleSaveClose();
        }}
      />
      {/* //on Load PQAS Grid Come Error */}
      <CommonModal
        className="dialog-420"
        data-testid="common-modal-warning"
        open={loadPQASGridErrorAlert?.alert}
        viewAction
        viewHeader
        onOk={() => {
          dispatch(
            setOnLoadPQASGridError({
              alert: false,
              msg: '',
            })
          );
        }}
        onClose={() => {
          dispatch(
            setOnLoadPQASGridError({
              alert: false,
              msg: '',
            })
          );
        }}
        okTitle="Ok"
        modalTitle={modalTitle}
        childrenComponent={
          <div className="p-3">{loadPQASGridErrorAlert?.msg}</div>
        }
        onCancel={() => {
          dispatch(
            setOnLoadPQASGridError({
              alert: false,
              msg: '',
            })
          );
        }}
      />
    </div>
  );
});
export default DetailScreenAllocatePaymentComponent;
